(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };
},{"core-js/library/fn/array/from":8}],2:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };
},{"core-js/library/fn/object/assign":9}],3:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };
},{"core-js/library/fn/symbol":10}],4:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };
},{"core-js/library/fn/symbol/iterator":11}],5:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _assign = require("../core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
},{"../core-js/object/assign":2}],6:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _from = require("../core-js/array/from");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};
},{"../core-js/array/from":1}],7:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _iterator = require("../core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("../core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
},{"../core-js/symbol":3,"../core-js/symbol/iterator":4}],8:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;

},{"../../modules/_core":18,"../../modules/es6.array.from":74,"../../modules/es6.string.iterator":78}],9:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;

},{"../../modules/_core":18,"../../modules/es6.object.assign":76}],10:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;

},{"../../modules/_core":18,"../../modules/es6.object.to-string":77,"../../modules/es6.symbol":79,"../../modules/es7.symbol.async-iterator":80,"../../modules/es7.symbol.observable":81}],11:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');

},{"../../modules/_wks-ext":71,"../../modules/es6.string.iterator":78,"../../modules/web.dom.iterable":82}],12:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],13:[function(require,module,exports){
module.exports = function () { /* empty */ };

},{}],14:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":36}],15:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":63,"./_to-iobject":65,"./_to-length":66}],16:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":17,"./_wks":72}],17:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],18:[function(require,module,exports){
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],19:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":47,"./_property-desc":57}],20:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":12}],21:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],22:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":27}],23:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":28,"./_is-object":36}],24:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],25:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":52,"./_object-keys":55,"./_object-pie":56}],26:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var ctx = require('./_ctx');
var hide = require('./_hide');
var has = require('./_has');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":18,"./_ctx":20,"./_global":28,"./_has":29,"./_hide":30}],27:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],28:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],29:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],30:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":22,"./_object-dp":47,"./_property-desc":57}],31:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":28}],32:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":22,"./_dom-create":23,"./_fails":27}],33:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":17}],34:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":42,"./_wks":72}],35:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":17}],36:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],37:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":14}],38:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":30,"./_object-create":46,"./_property-desc":57,"./_set-to-string-tag":59,"./_wks":72}],39:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":26,"./_hide":30,"./_iter-create":38,"./_iterators":42,"./_library":43,"./_object-gpo":53,"./_redefine":58,"./_set-to-string-tag":59,"./_wks":72}],40:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":72}],41:[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],42:[function(require,module,exports){
module.exports = {};

},{}],43:[function(require,module,exports){
module.exports = true;

},{}],44:[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":27,"./_has":29,"./_is-object":36,"./_object-dp":47,"./_uid":69}],45:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = require('./_descriptors');
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

},{"./_descriptors":22,"./_fails":27,"./_iobject":33,"./_object-gops":52,"./_object-keys":55,"./_object-pie":56,"./_to-object":67}],46:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":14,"./_dom-create":23,"./_enum-bug-keys":24,"./_html":31,"./_object-dps":48,"./_shared-key":60}],47:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":14,"./_descriptors":22,"./_ie8-dom-define":32,"./_to-primitive":68}],48:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":14,"./_descriptors":22,"./_object-dp":47,"./_object-keys":55}],49:[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":22,"./_has":29,"./_ie8-dom-define":32,"./_object-pie":56,"./_property-desc":57,"./_to-iobject":65,"./_to-primitive":68}],50:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":51,"./_to-iobject":65}],51:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":24,"./_object-keys-internal":54}],52:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],53:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":29,"./_shared-key":60,"./_to-object":67}],54:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":15,"./_has":29,"./_shared-key":60,"./_to-iobject":65}],55:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":24,"./_object-keys-internal":54}],56:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],57:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],58:[function(require,module,exports){
module.exports = require('./_hide');

},{"./_hide":30}],59:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":29,"./_object-dp":47,"./_wks":72}],60:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":61,"./_uid":69}],61:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":18,"./_global":28,"./_library":43}],62:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":21,"./_to-integer":64}],63:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":64}],64:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],65:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":21,"./_iobject":33}],66:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":64}],67:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":21}],68:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":36}],69:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],70:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":18,"./_global":28,"./_library":43,"./_object-dp":47,"./_wks-ext":71}],71:[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":72}],72:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":28,"./_shared":61,"./_uid":69}],73:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":16,"./_core":18,"./_iterators":42,"./_wks":72}],74:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":19,"./_ctx":20,"./_export":26,"./_is-array-iter":34,"./_iter-call":37,"./_iter-detect":40,"./_to-length":66,"./_to-object":67,"./core.get-iterator-method":73}],75:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":13,"./_iter-define":39,"./_iter-step":41,"./_iterators":42,"./_to-iobject":65}],76:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":26,"./_object-assign":45}],77:[function(require,module,exports){

},{}],78:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":39,"./_string-at":62}],79:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var toObject = require('./_to-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $GOPS = require('./_object-gops');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":14,"./_descriptors":22,"./_enum-keys":25,"./_export":26,"./_fails":27,"./_global":28,"./_has":29,"./_hide":30,"./_is-array":35,"./_is-object":36,"./_library":43,"./_meta":44,"./_object-create":46,"./_object-dp":47,"./_object-gopd":49,"./_object-gopn":51,"./_object-gopn-ext":50,"./_object-gops":52,"./_object-keys":55,"./_object-pie":56,"./_property-desc":57,"./_redefine":58,"./_set-to-string-tag":59,"./_shared":61,"./_to-iobject":65,"./_to-object":67,"./_to-primitive":68,"./_uid":69,"./_wks":72,"./_wks-define":70,"./_wks-ext":71}],80:[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":70}],81:[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":70}],82:[function(require,module,exports){
require('./es6.array.iterator');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var TO_STRING_TAG = require('./_wks')('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

},{"./_global":28,"./_hide":30,"./_iterators":42,"./_wks":72,"./es6.array.iterator":75}],83:[function(require,module,exports){
"use strict";

angular.module('cu', []);

require('./services');

},{"./services":85}],84:[function(require,module,exports){
"use strict";

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').factory('backend', ['$q', '$http', '$timeout', '$window', '$rootScope', 'utils', 'uniqueTabIdGenerator', 'watchman', function ($q, $http, $timeout, $window, $rootScope, utils, uniqueTabIdGenerator, watchman) {

    var service = {
        ready: init(),
        getAlias: getAlias,
        hasAlias: hasAlias,
        getParam: getParam,
        getEnvironmentUrls: getEnvironmentUrls,
        getEnvironmentUrl: getEnvironmentUrl,
        getOrderInfo: getOrderInfo,
        updateOrderInfo: updateOrderInfo,
        clearOrderInfo: clearOrderInfo,
        clearOrderInfoListeners: clearOrderInfoListeners,
        addOrderInfoListener: addOrderInfoListener,
        addToOrder: addToOrder,
        confirmPassengersSelection: confirmPassengersSelection,
        changePassengerSelection: changePassengerSelection,
        viewCraft: viewCraft,
        getCountryByCode: getCountryByCode,
        getCountryNameByCode: getCountryNameByCode,
        getCountriesList: getCountriesList,
        selectSeatNumber: selectSeatNumber,
        removeSeatNumber: removeSeatNumber,
        getDocumentTypesList: getDocumentTypesList,
        updateOrderServices: updateOrderServices,
        addUpdateOrderServicesListener: addUpdateOrderServicesListener,
        addExtraServiceListener: addExtraServiceListener,
        addExtraServiceErrorListener: addExtraServiceErrorListener,
        clearUpdateOrderServicesListeners: clearUpdateOrderServicesListeners,
        getAvailableDocumentsForAeroexpress: getAvailableDocumentsForAeroexpress,
        modifyExtraService: modifyExtraService,
        removeExtraService: removeExtraService,
        modifyDataSeat: modifyDataSeat,
        checkVisaFields: checkVisaFields,
        confirmCheckin: confirmCheckin,
        boardingPassEmail: boardingPassEmail,
        waitPayment: waitPayment,
        clearSession: clearSession,
        cancelCheckin: cancelCheckin,
        switchDefaultSelectedServices: switchDefaultSelectedServices,
        aeroexpressSchedule: aeroexpressSchedule,
        setCancelSessionHandler: setCancelSessionHandler,
        sortExtraServices: sortExtraServices
    },
        aliasesIndex = {},
        paramsIndex = {},
        extraServiceListeners = [],
        extraServiceErrorListeners = [];

    var countriesDict = [],
        documentTypesList = [],
        orderInfoStateListeners = [],
        orderInfoListeners = [],
        orderServicesListeners = [],
        environmentUrls = {},
        orderInfo = false,
        cancelSessionHandler = void 0;

    return service;

    function init() {
        if (!checkTabIdParam()) {
            $window.location = './';
            return;
        }
        return $q.all([fetchJSON('json/get-params').then(initParams), fetchJSON(o2context.staticFolderRelativePath + '/aliases-' + o2context.systemLanguage + '.json').then(initAliases), fetchJSON('json/astra-countries-dictionary').then(initCountriesDict), fetchJSON('json/application-constants').then(initApplicationConstants)]);
    }

    function getAlias(code) {
        if (o2context.advancedAliasesMode) {
            return code;
        }
        if (code) {
            if (aliasesIndex[code] === undefined) {
                if (storeAliasToList(code, 'undefinedAliases')) {
                    // eslint-disable-next-line
                    console.debug('Alias not defined: ', code);
                }
                return code;
            } else {
                return aliasesIndex[code];
            }
        }
    }

    function hasAlias(code) {
        return aliasesIndex[code] !== undefined;
    }

    function getParam(code) {
        var value = paramsIndex[code],
            numValue = void 0;
        if (value === "true") {
            value = true;
        } else if (value === "false" || value === "") {
            value = false;
        } else {
            numValue = value * 1;
            if (numValue === 0 || numValue && typeof numValue == 'number') {
                value = numValue;
            }
        }
        return value;
    }

    function getEnvironmentUrls() {
        return environmentUrls;
    }

    function getEnvironmentUrl(code) {
        return environmentUrls[code] || false;
    }

    function getOrderInfo() {
        return orderInfo;
    }

    function setOrderInfo(data) {
        orderInfo = data;
        orderInfoListeners.forEach(function (cb) {
            cb(orderInfo);
        });
    }

    function addOrderInfoListener(callback, stateCallback, initCall) {
        orderInfoListeners.push(callback);
        if (stateCallback) {
            orderInfoStateListeners.push(stateCallback);
        }
        if (initCall) {
            if (orderInfo) {
                callback(orderInfo);
            }
        }
    }

    function clearOrderInfoListeners() {
        orderInfoListeners = [];
        orderInfoStateListeners = [];
    }

    function clearOrderInfo() {
        setOrderInfo(false);
    }

    function updateOrderInfo() {
        orderInfoStateListeners.forEach(function (cb) {
            cb(false);
        });
        return $q(function (resolve, reject) {
            fetchJSON('json/order-info', 'GET', {}, { keyEvent: 'order-info' }).then(function (resp) {
                checkPaymentInProgress(resp);
                checkWebCheckinStatusTimer(resp);
                if (resp.passengers && resp.passengers.length) {
                    setOrderInfo(reformatOrderInfo(resp));
                    orderInfoStateListeners.forEach(function (cb) {
                        cb(true);
                    });
                    resolve(getOrderInfo());
                } else {
                    reject({
                        error: 'oxygen-check-in.emptyOrder'
                    });
                }
                if (resp.events) {
                    checkOrderEvents(resp.events);
                }
            }, reject);
        });
    }

    function waitPayment() {

        var paymentStatusAttemptsInterval = getParam('oxygen-check-in.paymentStatusAttemptsInterval') * 1000;

        return $q(function (resolve, reject) {
            checkOrderStatus().then(function (resp) {
                if (resp.status === 'PAID') {
                    resolve();
                } else if (resp.status === 'CANNOT_BE_PAID' || resp.status === 'NOT_PAID') {
                    reject();
                } else {
                    $timeout(function () {
                        waitPayment().then(resolve, reject);
                    }, paymentStatusAttemptsInterval);
                }
            }, reject);
        });
    }

    function checkOrderStatus() {
        return fetchJSON('json/check-order-status', 'GET', {}, { ignoreError: true });
    }

    function clearSession() {
        return fetchJSON('json/clear-session');
    }

    function addToOrder(params, withoutOrderUpdate) {
        return $q(function (resolve, reject) {
            fetchJSON('json/add-to-order', 'POST', params, { keyEvent: 'add-to-order', ignoreError: true }).then(function (resp) {
                if (resp.result === 'OK') {
                    if (withoutOrderUpdate) {
                        resolve(resp);
                    } else {
                        updateOrderInfo().then(resolve, reject);
                    }
                } else {
                    reject(resp);
                }
            }, reject);
        });
    }

    function viewCraft(segNum, passNum, imgPath, bort) {
        return $q(function (resolve, reject) {
            fetchJSON('json/view-craft', 'POST', {
                segmentIndex: segNum,
                passengerIndex: passNum
            }).then(function (resp) {
                var decks = getAvailableViewCraftDecks(resp);
                if (bort && getParam('oxygen-check-in.useSvgAircraftScheme')) {
                    $q.all(decks.map(function (deck) {
                        return $http.get(imgPath + '/' + bort + '/' + deck + '.svg?buildNumber=' + o2context.serverBuildNumber);
                    })).then(function (respSvg) {
                        resolve(reformatViewCraft(resp, decks, respSvg));
                    }, function () {
                        resolve(reformatViewCraft(resp));
                    });
                } else {
                    resolve(reformatViewCraft(resp));
                }
            }, reject);
        });
    }

    function confirmPassengersSelection(params) {
        return fetchJSON('json/confirm-passengers-selection', 'POST', { selected: JSON.stringify(params) }, { keyEvent: 'confirm-passengers-selection' });
    }

    function changePassengerSelection(passengerIndex, selected) {
        return fetchJSON('json/change-passenger-selection', 'POST', { passengerIndex: passengerIndex, selected: selected });
    }

    function cancelCheckin(passengerIndex) {
        return fetchJSON('json/cancel-check-in', 'POST', { passengerIndex: passengerIndex }, { keyEvent: 'cancel-check-in' });
    }

    function selectSeatNumber(params) {
        return fetchJSON('json/select-seat-number', 'POST', params, { keyEvent: 'select-seat-number' });
    }

    function removeSeatNumber(params) {
        return fetchJSON('json/remove-seat-number', 'POST', params, { keyEvent: 'remove-seat-number' });
    }

    function getCountryNameByCode(code) {
        var country = getCountryByCode(code);
        if (country && country.value) {
            return country.value;
        } else {
            return code;
        }
    }

    function getCountryByCode(code) {
        return _.findWhere(countriesDict, { code: code });
    }

    function getCountriesList() {
        return countriesDict;
    }

    function getDocumentTypesList() {
        return documentTypesList;
    }

    function getExtraServices() {
        return fetchJSON('json/extra-services');
    }

    function sortExtraServices(list) {
        var definedOrder = void 0;
        if (getParam('check-in.extraServicesOrder')) {
            try {
                definedOrder = JSON.parse(getParam('check-in.extraServicesOrder'));
            } catch (err) {
                // eslint-disable-next-line
                console.log('Invalid check-in.extraServicesOrder: ', err);
            }
        }
        if (definedOrder) {
            return definedOrder.map(function (code) {
                var item = _.findWhere(list, { code: code });
                if (code === 'insuranceOnline' && !item) {
                    item = _.findWhere(list, { code: 'insurance' });
                }
                return item;
            }).filter(function (item) {
                return !!item;
            });
        } else {
            return list;
        }
    }

    function updateOrderServices() {

        return $q(function (resolve, reject) {

            getExtraServices().then(function (extraServicesResp) {
                updateOrderInfo().then(function (orderInfoResp) {
                    handleSuccess([{
                        extraServiceGroups: sortExtraServices(extraServicesResp.extraServiceGroups || [])
                    }, orderInfoResp]);
                }, handleError);
            }, handleError);

            function handleSuccess(resp) {
                orderServicesListeners.forEach(function (listener) {
                    if (listener.success) {
                        listener.success(resp);
                    }
                });
                resolve(resp);
                return resp;
            }

            function handleError(resp) {
                orderServicesListeners.forEach(function (listener) {
                    if (listener.error) {
                        listener.error(resp);
                    }
                });
                reject(resp);
                return resp;
            }
        });
    }

    function addUpdateOrderServicesListener(successCallback, errorCallback) {
        orderServicesListeners.push({
            success: successCallback,
            error: errorCallback
        });
    }

    function clearUpdateOrderServicesListeners() {
        orderServicesListeners = [];
    }

    function addExtraServiceListener(cb) {
        extraServiceListeners.push(cb);
    }

    function addExtraServiceErrorListener(cb) {
        extraServiceErrorListeners.push(cb);
    }

    function getAvailableDocumentsForAeroexpress(params) {
        return fetchJSON('json/available-documents-for-aeroexpress', 'POST', params);
    }

    function modifyExtraService(params, preventUpdate) {
        extraServiceListeners.forEach(function (cb) {
            cb(false);
        });

        return $q(function (resolve, reject) {
            fetchJSON('json/extra-services-modify', 'POST', params, { keyEvent: 'extra-services-modify' }).then(function () {
                if (preventUpdate) {
                    resolve();
                } else {
                    updateOrderServices().then(resolve, reject);
                }

                extraServiceListeners.forEach(function (cb) {
                    cb(true);
                });
            }, function (resp) {
                if (preventUpdate) {
                    reject(resp);
                } else {
                    updateOrderServices().then(function () {
                        reject(resp);
                    }, function () {
                        reject(resp);
                    });
                }

                extraServiceErrorListeners.forEach(function (cb) {
                    cb(resp, params);
                });
            });
        });
    }

    function removeExtraService(params, preventUpdate) {
        extraServiceListeners.forEach(function (cb) {
            cb(false);
        });

        return $q(function (resolve, reject) {
            fetchJSON('json/extra-services-remove', 'POST', params, { keyEvent: 'extra-services-remove' }).then(function () {
                if (preventUpdate) {
                    resolve();
                } else {
                    updateOrderServices().then(resolve, reject);
                }

                extraServiceListeners.forEach(function (cb) {
                    cb(true);
                });
            }, function (resp) {
                if (preventUpdate) {
                    reject(resp);
                } else {
                    updateOrderServices().then(function () {
                        reject(resp);
                    }, function () {
                        reject(resp);
                    });
                }

                extraServiceErrorListeners.forEach(function (cb) {
                    cb(resp, params);
                });
            });
        });
    }

    function modifyDataSeat(params) {
        return fetchJSON('json/modify-data-seat', 'POST', params, { ignoreError: true });
    }

    function confirmCheckin(params) {
        return $q(function (resolve, reject) {
            fetchJSON('json/confirm-check-in', 'POST', params, { keyEvent: 'confirm-check-in' }).then(function (resp) {
                resolve(reformatConfirmCheckin(resp));
            }, reject);
        });
    }

    function boardingPassEmail(params) {
        return fetchJSON('json/check-in-finished-email', 'POST', params, { keyEvent: 'boarding-pass-mail-send' });
    }

    function switchDefaultSelectedServices(esList, es) {
        var defaultSelectedServices = (esList || []).filter(function (code) {
            return !es[code].active && es[code].defaultSelected;
        }).map(function (code) {
            return {
                code: code
            };
        }),
            queue = void 0;

        defaultSelectedServices = _.flatten(defaultSelectedServices);

        if (defaultSelectedServices.length) {
            defaultSelectedServices.forEach(function (params, num) {
                var isLast = num === defaultSelectedServices.length - 1;

                if (!queue) {
                    queue = modifyExtraService(params, !isLast);
                } else {
                    queue = queue.then(function () {
                        return modifyExtraService(params, !isLast);
                    });
                }
            });

            return queue;
        } else {
            return $q(function (resolve) {
                resolve();
            });
        }
    }

    function aeroexpressSchedule(params) {
        return fetchJSON('json/aeroexpress-schedule', 'POST', params);
    }

    // Private methods

    function initAliases(resp) {
        resp.aliases.forEach(function (alias) {
            aliasesIndex[alias.code] = alias.value;
        });
    }

    function initParams(resp) {
        resp.parameters.forEach(function (param) {
            paramsIndex[param.code] = param.value;
        });
        initEnvironmentUrls();
        initDocumentTypesList();
    }

    function initEnvironmentUrls() {
        try {
            environmentUrls = JSON.parse(getParam('check-in.environmentUrls'));
        } catch (err) {
            // eslint-disable-next-line
            console.log('Invalid check-in.environmentUrls: ', err);
        }
    }

    function initDocumentTypesList() {
        var listStr = getParam('check-in.documentTypeList');
        if (listStr) {
            documentTypesList = listStr.split(',').map(function (c) {
                return c.trim();
            });
        }
    }

    function initCountriesDict(resp) {
        countriesDict = reformatCountriesList(resp.items) || [];
    }

    function reformatCountriesList(list) {
        list = list.sort(function (a, b) {

            if (a.code === 'RUS') {
                return -1;
            }
            if (b.code === 'RUS') {
                return 1;
            }

            if (a.value > b.value) {
                return 1;
            }
            if (a.value < b.value) {
                return -1;
            }
            return 0;
        });

        return list;
    }

    function initApplicationConstants(data) {
        service.applicationConstants = data;
    }

    function storeAliasToList(aliasCode, listCode) {
        if (!o2context[listCode]) {
            o2context[listCode] = [];
        }

        if (!utils.hasInList(o2context[listCode], aliasCode)) {
            o2context[listCode].push(aliasCode);

            return true;
        } else {
            return false;
        }
    }

    function checkPaymentInProgress(orderInfo) {
        /*
        Если сейчас идет процесс оплаты, то надо либо делать редирект на страницу МПС,
        либо блокировать экран и ждать, пока оплата подтвердится.
        Был сделан специальный признак redirectResultFromIPS, котоырй говорит о том,
        был ли сделан переход с платежной страницы. Если он был сделан, то надо ждать оплату,
        если не был - редиректить на страницу МПС.
        */
        if (orderInfo.paymentInProgress) {
            if (orderInfo.paymentInProgress.redirectResultFromIPS) {
                $window.location = './#/pending-payment-status';
            } else if (orderInfo.paymentInProgress.redirectTo) {
                $window.location = orderInfo.paymentInProgress.redirectTo;
            }
        }
    }

    function checkWebCheckinStatusTimer(orderInfo) {
        if (orderInfo.segments && orderInfo.segments.length) {
            orderInfo.segments.forEach(function (segment) {
                if (segment && segment.stages && segment.status && segment.stages.webCheckInOpenUtc && segment.stages.webCheckInCloseUtc) {

                    var webCheckInCloseMoment = moment.utc(segment.stages.webCheckInCloseUtc, 'DD.MM.YYYY hh:mm');
                    var webCheckInOpenMoment = moment.utc(segment.stages.webCheckInOpenUtc, 'DD.MM.YYYY hh:mm');
                    var serverMoment = moment.utc(o2context.serverDateTime);

                    if (segment.status === 'OPENED') {
                        schedulePageReload(webCheckInCloseMoment.diff(serverMoment), segment.status);
                    } else if (segment.status === 'CLOSED') {
                        schedulePageReload(webCheckInOpenMoment.diff(serverMoment), segment.status);
                    }
                }
            });
        }
    }

    function schedulePageReload(diff, status) {
        /* Будут обрабатываться только положительные задержки т.е. будущее время, а не прошлое */
        if (diff > 0) {

            var X = 60 * 1000;
            var N = 60 * 60 * 1000;
            var M = N - 5 * 60 * 1000;
            var FIVE_MIN = 5 * 60 * 1000;

            /*
             Страница вебчекина должна автоматом обновляться раз в шаг Х минут (Х=1 минута) если
                а) Пользователь уже "поискал" билет;
                б) Регистрация сейчас не открыта, ее плановое открытие в будущем и не более чем через N времени (N=60 мин).
             */

            if (status === 'CLOSED') {
                if (diff < N) {
                    updateReloadTimer(X);
                } else {
                    updateReloadTimer(diff - M);
                }
            }
            if (status === 'OPENED') {
                if (diff < FIVE_MIN) {
                    $rootScope.globalError = 'check-in.messages.checkinClosedSoon';
                }
                updateReloadTimer(diff);
            }
        }
    }

    function updateReloadTimer(reloadAfter) {
        var reloadAfterMin = Math.floor(reloadAfter / (60 * 1000));
        // eslint-disable-next-line
        console.log('Page will reload after ' + reloadAfterMin + ' min.');
        if (o2context.reloadTimer) {
            $timeout.cancel(o2context.reloadTimer);
        }
        o2context.reloadTimer = $timeout(function () {
            $window.location.reload();
        }, reloadAfter);
    }

    function reformatOrderInfo(data) {
        var hasPassengersWithForbiddenRemCode = false;
        data.hasOpenedSegments = false;
        data.hasAvailablePassengers = false;
        data.allUnavailablePassengersWithForbiddenRemCode = true;
        data.hasPassengersWithoutSeat = false;
        data.hasPassengersWithSeat = false;
        if (data.segments && data.segments.length) {
            data.segments.forEach(function (segment) {
                if (segment.status === 'OPENED') {
                    data.hasOpenedSegments = true;
                } else {
                    if (segment.status === 'CLOSED') {
                        var webCheckInCloseMoment = moment.utc(segment.stages.webCheckInCloseUtc, 'DD.MM.YYYY hh:mm');
                        var webCheckInOpenMoment = moment.utc(segment.stages.webCheckInOpenUtc, 'DD.MM.YYYY hh:mm');
                        var serverMoment = moment.utc(o2context.serverDateTime);

                        // Если время открытия регистрации в будущем, то рейс "ещё" закрыт
                        if (webCheckInOpenMoment.isAfter(serverMoment)) {
                            segment.isClosedYet = true;
                        }
                        // Если время закрытия регистрации в прошлом, то рейс "уже" закрыт
                        if (webCheckInCloseMoment.isBefore(serverMoment)) {
                            segment.isClosedAlready = true;
                        }
                    }
                }
            });
            data.isAllSegmentsClosedYet = data.segments.every(function (segment) {
                return segment.isClosedYet;
            });
            data.isAllSegmentsClosedAlready = data.segments.every(function (segment) {
                return segment.isClosedAlready;
            });
        }
        data.astraSeatTotalPaidPrice = 0;
        data.astraSeatTotalNotPaidPrice = 0;
        if (data.passengers && data.passengers.length) {
            data.passengers.forEach(function (passenger, num) {
                passenger.segments.forEach(function (segment, segmentNum) {
                    segment.seat = segment.chosenSeatThroughGui || segment.alreadyAssignedSeatInAstra || false;
                    if (!segment.seat) {
                        data.hasPassengersWithoutSeat = true;
                    } else {
                        data.hasPassengersWithSeat = true;
                        if (segment.seat.paid) {
                            data.astraSeatTotalPaidPrice += segment.seat.cost;
                        } else {
                            data.astraSeatTotalNotPaidPrice += segment.seat.cost;
                        }
                        if (!data.astraSeatTotalCurrency && segment.seat.currency) {
                            data.astraSeatTotalCurrency = segment.seat.currency;
                        }
                    }
                    if (segment.visa) {
                        if (data.passengersType === 'CHECKED') {
                            segment.visa.required = false;
                        }
                        if (segment.visa.required && !segment.visa.userClaimedVisaNotRequired) {
                            segment.visa.valid = checkVisaFields(segment.visa);
                        }
                        if (segment.visa.fields) {
                            segment.visa.fields = segment.visa.fields.map(addVisaFieldFullName);
                        }
                    }
                    segment.extraBag = getExtraBaggageValue(passenger.ticketNumbers, data.segments[segmentNum].flightNumber, data.sirenaOrder);
                    segment.seatSelectAvailable = utils.hasInList(segment.possibleActions, 'CHANGE_SEAT');
                    segment.boardingPassAvailable = utils.hasInList(segment.possibleActions, 'GET_BOARDING_PASS');
                    segment.walletAvailable = utils.hasInList(segment.possibleActions, 'GET_WALLET');
                    segment.modifyDocumentsAvailable = utils.hasInList(segment.possibleActions, 'MODIFY_DOCUMENTS_AND_FFP');
                    if (segment.boardingPassAvailable) {
                        data.hasPassengerSegmentsWithBoardingPass = true;
                    }
                    if (!segment.boardingPassAvailable) {
                        data.hasPassengerSegmentsWithoutBoardingPass = true;
                    }
                });
                passenger.cancelCheckinAvailable = utils.hasInList(passenger.possibleActions, 'WEB_CANCEL');
                passenger.index = num;
                if (passenger.child) {
                    passenger.child.segments.forEach(function (segment) {
                        if (segment.visa) {
                            if (data.passengersType === 'CHECKED') {
                                segment.visa.required = false;
                            }
                            if (segment.visa.required && !segment.visa.userClaimedVisaNotRequired) {
                                segment.visa.valid = checkVisaFields(segment.visa);
                            }
                            if (segment.visa.fields) {
                                segment.visa.fields = segment.visa.fields.map(addVisaFieldFullName);
                            }
                        }
                        segment.modifyDocumentsAvailable = utils.hasInList(segment.possibleActions, 'MODIFY_DOCUMENTS_AND_FFP');
                    });
                    passenger.child.isAvailable = passenger.isAvailable;
                }
                if (passenger.ticketNumbers) {
                    passenger.ticketNumbersList = passenger.ticketNumbers.split(',');
                }
                if (passenger.category === 'РБ' && data.segments && data.segments[0] && utils.calcAge(passenger.birthDate, data.segments[0].departureDate) <= 2) {
                    passenger.showChildIcon = true;
                }
                if (passenger.isAvailable) {
                    data.hasAvailablePassengers = true;
                } else if (passenger.unavailabilityReason === 'FORBIDDEN_REM_CODE') {
                    $rootScope.globalError = 'check-in.search.hasForbiddenRemCodeAlert';
                    hasPassengersWithForbiddenRemCode = true;
                } else {
                    data.allUnavailablePassengersWithForbiddenRemCode = false;
                }
            });
        }
        if (data.sirenaOrder) {
            if (data.sirenaOrder.segments) {
                data.sirenaOrder.plainFlights = angular.copy(data.sirenaOrder.segments);
            }
            if (data.sirenaOrder.pricesEditable) {
                data.sirenaOrder.pricesEditable.totalExtraServiceByGroup = reformatExtraServiceByGroupPrices(data.sirenaOrder.pricesEditable.totalExtraServiceByGroup);
            }
            if (data.sirenaOrder.pricesIssued) {
                data.sirenaOrder.pricesIssued.totalExtraServiceByGroup = reformatExtraServiceByGroupPrices(data.sirenaOrder.pricesIssued.totalExtraServiceByGroup);
            }
            if (data.sirenaOrder.pricesNotIssued) {
                data.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup = reformatExtraServiceByGroupPrices(data.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup);
            }

            if (data.sirenaOrder.passengers) {
                data.sirenaOrder.passengers = data.sirenaOrder.passengers.sort(function (a, b) {
                    if (a.id > b.id) {
                        return 1;
                    } else if (a.id < b.id) {
                        return -1;
                    } else {
                        return 0;
                    }
                });
            }

            if (data.sirenaOrder.passengers && data.sirenaOrder.plainFlights) {
                if (data.sirenaOrder.editableExtraServices) {
                    data.sirenaOrder.editableExtraServices = data.sirenaOrder.editableExtraServices.map(utils.markInsuranceOnline);
                    data.sirenaOrder.groupedEditableExtraServices = groupExtraServices(data.sirenaOrder.passengers, data.sirenaOrder.plainFlights, data.sirenaOrder.editableExtraServices);
                    data.sirenaOrder.editableExtraServicesHeap = generateServicesHeap(data.sirenaOrder.editableExtraServices);
                }
                if (data.sirenaOrder.allExtraServices) {
                    data.sirenaOrder.allExtraServices = data.sirenaOrder.allExtraServices.map(utils.markInsuranceOnline);
                    data.sirenaOrder.allExtraServicesHeap = generateServicesHeap(data.sirenaOrder.allExtraServices);
                    data.sirenaOrder.groupedAllExtraServices = groupExtraServices(data.sirenaOrder.passengers, data.sirenaOrder.plainFlights, data.sirenaOrder.allExtraServices);
                }
                if (data.sirenaOrder.issuedExtraServices) {
                    data.sirenaOrder.issuedExtraServices = data.sirenaOrder.issuedExtraServices.map(utils.markInsuranceOnline);
                    data.sirenaOrder.groupedIssuedExtraServices = groupExtraServices(data.sirenaOrder.passengers, data.sirenaOrder.plainFlights, data.sirenaOrder.issuedExtraServices);
                }
                if (data.sirenaOrder.passengers[0]) {
                    data.sirenaOrder.singlePnr = data.sirenaOrder.passengers[0].pnr;
                    data.sirenaOrder.passengers.forEach(function (pax) {
                        if (data.sirenaOrder.singlePnr !== pax.pnr) {
                            data.sirenaOrder.singlePnr = false;
                        }
                    });
                }
            }
        }
        if (hasPassengersWithForbiddenRemCode) {
            return false;
        }

        if (data.sirenaOrder) {

            if (data.astraSeatTotalNotPaidPrice) {
                if (!data.sirenaOrder.pricesNotIssued) {
                    data.sirenaOrder.pricesNotIssued = {};
                    if (data.astraSeatTotalCurrency) {
                        data.sirenaOrder.pricesNotIssued.currency = data.astraSeatTotalCurrency;
                    }
                }
                if (!data.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup || !data.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup.seat) {
                    data.sirenaOrder.pricesNotIssued.totalExtraServicesWithAstraSeats = Big(data.sirenaOrder.pricesNotIssued.totalExtraServices || 0).plus(data.astraSeatTotalNotPaidPrice).toFixed(2);
                }
            }

            if (data.astraSeatTotalPaidPrice) {
                if (!data.sirenaOrder.pricesIssued) {
                    data.sirenaOrder.pricesIssued = {};
                    if (data.astraSeatTotalCurrency) {
                        data.sirenaOrder.pricesIssued.currency = data.astraSeatTotalCurrency;
                    }
                }
                if (!data.sirenaOrder.pricesIssued.totalExtraServiceByGroup || !data.sirenaOrder.pricesIssued.totalExtraServiceByGroup.seat) {
                    data.sirenaOrder.pricesIssued.totalExtraServicesWithAstraSeats = Big(data.sirenaOrder.pricesIssued.totalExtraServices || 0).plus(data.astraSeatTotalPaidPrice).toFixed(2);
                }
            }
        }

        return data;
    }

    function getExtraBaggageValue(astraTicketNumbers, flightNumber, sirenaOrder) {
        var extraBag = 0;
        var sirenaSegmentId = void 0;
        var sirenaPaxId = void 0;
        var sirenaPaxPnr = void 0;
        var astraTicketNumbersList = astraTicketNumbers && astraTicketNumbers.split(',');
        if (flightNumber && sirenaOrder && sirenaOrder.segments && sirenaOrder.passengers && astraTicketNumbersList && astraTicketNumbersList.length && sirenaOrder.allExtraServices && sirenaOrder.allExtraServices.length) {
            sirenaOrder.segments.forEach(function (segment) {
                if (segment.flightNumber === flightNumber) {
                    sirenaSegmentId = segment.id;
                }
            });
            sirenaOrder.passengers.forEach(function (pax) {
                astraTicketNumbersList.forEach(function (astraTicketNumber) {
                    pax.ticketNumbers.forEach(function (sirenaTicketNumber) {
                        if (sirenaTicketNumber === astraTicketNumber) {
                            sirenaPaxId = pax.id;
                            sirenaPaxPnr = pax.pnr;
                        }
                    });
                });
            });
        }

        if (sirenaSegmentId !== undefined && sirenaPaxPnr !== undefined && sirenaPaxId !== undefined) {
            sirenaOrder.allExtraServices.forEach(function (servicesGroup) {
                if (servicesGroup.code === 'baggage' && servicesGroup.passengers && servicesGroup.passengers.length) {
                    servicesGroup.passengers.forEach(function (paxBag) {
                        if (paxBag.id === sirenaPaxId && paxBag.pnr === sirenaPaxPnr && paxBag.segments && paxBag.segments.length) {
                            paxBag.segments.forEach(function (paxSegBag) {
                                if (paxSegBag.id === sirenaSegmentId && paxSegBag.selectedExtraServices && paxSegBag.selectedExtraServices[0] && paxSegBag.selectedExtraServices[0].extraProperties && paxSegBag.selectedExtraServices[0].extraProperties.weight) {
                                    extraBag = paxSegBag.selectedExtraServices[0].extraProperties.weight;
                                }
                            });
                        }
                    });
                }
            });
        }
        return extraBag;
    }

    function checkOrderEvents(events) {
        events.forEach(function (event) {
            if (!event.processedByJS) {
                watchman.notifyOrderEvent({
                    date: event.date,
                    type: event.type,
                    id: event.id,
                    extraInformation: event.extraInformation || false
                }, getOrderInfo());
                markTrackingEventProcessed(event.id);
            }
        });
    }

    function markTrackingEventProcessed(event_id) {
        return fetchJSON('json/mark-event-processed-by-js', 'POST', { event_id: event_id });
    }

    function addVisaFieldFullName(field) {
        field.fullName = 'visa' + utils.capitalizeFirstLetter(field.name);
        return field;
    }

    function groupExtraServices(passengers, plainFlights, servicesList) {
        var result = {};

        servicesList.forEach(function (editableService) {
            if (editableService.code === 'insurance') {
                result[editableService.code] = getPasSegItemsByInsuranceService(passengers, plainFlights, editableService);
            } else if (editableService.code === 'aeroexpress') {
                result[editableService.code] = getFareItemsByAeroexpressService(editableService);
            } else {
                result[editableService.code] = getPasSegItemsByService(passengers, plainFlights, editableService);
            }
        });
        return result;
    }

    function generateServicesHeap(servicesList) {
        var heap = [];

        if (servicesList && servicesList.length) {
            servicesList.forEach(function (servicesByType) {
                if (servicesByType.code === 'insurance') {
                    servicesByType.items.forEach(function (insItem) {
                        var item = angular.copy(insItem);
                        item.groupCode = servicesByType.code;
                        heap.push(item);
                    });
                } else if (servicesByType.passengers && servicesByType.passengers.length) {
                    servicesByType.passengers.forEach(function (servicesByPax) {
                        if (servicesByPax.segments && servicesByPax.segments.length) {
                            servicesByPax.segments.forEach(function (servicesByPaxSeg) {
                                if (servicesByPaxSeg.selectedExtraServices && servicesByPaxSeg.selectedExtraServices.length) {
                                    servicesByPaxSeg.selectedExtraServices.forEach(function (itemSource) {
                                        var item = angular.copy(itemSource);

                                        item.groupCode = servicesByType.code;
                                        item.passengerId = servicesByPax.id;
                                        item.mainSegmentId = servicesByPaxSeg.id;

                                        heap.push(item);
                                    });
                                }
                            });
                        }
                    });
                } else if (servicesByType.code === 'aeroexpress' && servicesByType.items) {
                    servicesByType.items.forEach(function (aeItem) {
                        var item = angular.copy(aeItem);
                        item.groupCode = servicesByType.code;
                        heap.push(item);
                    });
                }
            });
        }

        return heap;
    }

    function getPasSegItemsByService(passengers, plainFlights, editableService) {
        if (!editableService || !editableService.passengers) {
            return false;
        }

        return passengers.map(function (orderPassenger) {
            var editableServicePassenger = _.findWhere(editableService.passengers, {
                id: orderPassenger.id,
                pnr: orderPassenger.pnr
            });

            if (!editableServicePassenger || !editableServicePassenger.segments) {
                return false;
            }

            return plainFlights.map(function (orderSegment) {
                var editableServicePassengerSegment = _.findWhere(editableServicePassenger.segments, { id: orderSegment.id });
                if (!editableServicePassengerSegment || !editableServicePassengerSegment.selectedExtraServices || !editableServicePassengerSegment.selectedExtraServices.length) {
                    return false;
                }
                return editableServicePassengerSegment.selectedExtraServices;
            });
        });
    }

    function getPasSegItemsByInsuranceService(passengers, plainFlights, editableService) {
        if (!editableService || !editableService.items) {
            return false;
        }
        return passengers.map(function (orderPassenger) {
            var paxServiceItem = _.findWhere(editableService.items, {
                passengerId: orderPassenger.id,
                pnr: orderPassenger.pnr
            });
            if (paxServiceItem) {
                return plainFlights.map(function () {
                    return [paxServiceItem];
                });
            } else {
                return false;
            }
        });
    }

    function getFareItemsByAeroexpressService(editableService) {
        return editableService && editableService.items;
    }

    function checkVisaFields(visa) {
        var todayMoment = moment(o2context.serverDateTime);
        var field = void 0;
        for (var i = 0; i < visa.fields.length; i++) {
            field = visa.fields[i];
            if (field.required && !field.value) {
                return false;
            }
            if (field.value) {
                if (field.name === 'number' && !checkByRegExp(field.value, visa.isInternational ? service.applicationConstants.visaNumberLatRegexp : service.applicationConstants.visaNumberRegexp)) {
                    return false;
                }
                if (field.name === 'issuePlace' && !checkByRegExp(field.value, visa.isInternational ? service.applicationConstants.visaIssuePlaceLatRegexp : service.applicationConstants.visaIssuePlaceRegexp)) {
                    return false;
                }
                if (field.name === 'birthPlace' && !checkByRegExp(field.value, visa.isInternational ? service.applicationConstants.visaBirthPlaceLatRegexp : service.applicationConstants.visaBirthPlaceRegexp)) {
                    return false;
                }
                if (field.name === 'issueDate' && (!moment(field.value, "DD.MM.YYYY").isValid() || moment(field.value, "DD.MM.YYYY").isAfter(todayMoment))) {
                    return false;
                }
                if (field.name === 'expirationDate' && (!moment(field.value, "DD.MM.YYYY").isValid() || moment(field.value, "DD.MM.YYYY").isBefore(todayMoment))) {
                    return false;
                }
            }
        }
        return true;
    }

    function checkByRegExp(value, regExp) {
        return new RegExp(regExp).test(value);
    }

    function reformatExtraServiceByGroupPrices(totalExtraServiceByGroup) {
        if (totalExtraServiceByGroup) {
            totalExtraServiceByGroup = _.mapObject(_.indexBy(totalExtraServiceByGroup.map(utils.markInsuranceOnline), 'code'), function (item) {
                return item.price;
            });
        } else {
            totalExtraServiceByGroup = {};
        }
        return totalExtraServiceByGroup;
    }

    function getAvailableViewCraftDecks(resp) {
        var deckProps = [];
        if (resp && resp.cabins) {
            resp.cabins.forEach(function (cabin) {
                cabin.properties.forEach(function (prop) {
                    if (prop.indexOf('_DECK') !== -1 && !utils.hasInList(deckProps, prop)) {
                        deckProps.push(prop);
                    }
                });
            });
        }
        if (deckProps.length) {
            return deckProps.map(function (prop) {
                return prop.replace('_DECK', '');
            });
        } else {
            return ['COMMON'];
        }
    }

    function reformatViewCraft(data, decks, images) {

        var viewCraftCurrency = false;

        if (decks && decks.length && images.length) {
            data.images = decks.map(function (deck, num) {
                return {
                    deck: deck,
                    svg: images[num].data
                };
            });
        } else if (data.cabins && data.cabins.length) {
            _.each(data.cabins, function (cabin) {
                var rowNum = void 0,
                    placeNum = void 0,

                // количество пустых мест для текущего просматриваемого вертикального ряда
                currentRowEmptyPlaces = void 0,

                // x-координаты вертикальных рядов, в которых больше всего пустых мест,
                // там будут на карте мест рисоваться номера рядов
                emptyVerticalRowsXCoordinates = void 0,

                // "длина" пустых рядов, все ряды с такой длиной будут выбираться, и в них будут рисоваться номера
                amountOfPlacesInEmptyVerticalRows = -1;
                cabin.tableRows = [];
                cabin.tableCols = [];
                for (rowNum = 0; rowNum < cabin.yCount; rowNum++) {
                    cabin.tableRows[rowNum] = [];
                    for (placeNum = 0; placeNum < cabin.xCount; placeNum++) {
                        cabin.tableRows[rowNum][placeNum] = {
                            isEmptyCell: true,
                            y: rowNum,
                            x: placeNum
                        };
                    }
                }

                _.each(cabin.places, function (place) {
                    if (!viewCraftCurrency && place.rate && place.rate.currencyCode) {
                        viewCraftCurrency = place.rate.currencyCode;
                    }
                });

                _.each(cabin.places, function (place) {
                    if (place.seatNumber) {
                        place.colName = place.seatNumber.charAt(place.seatNumber.length - 1);
                        place.rowName = place.seatNumber.slice(0, place.seatNumber.length - 1);
                        if (!place.rate && place.available && viewCraftCurrency) {
                            place.rate = { currencyCode: viewCraftCurrency, value: 0 };
                        }
                        cabin.tableCols[place.x] = place.colName;
                    } else {
                        if (!cabin.tableCols[place.x]) {
                            cabin.tableCols[place.x] = "";
                        }
                    }
                    cabin.tableRows[place.y][place.x] = place;
                });

                // Проходим по каждому вертикальному ряду, смотрим там количество пустых мест,
                // на основании этого инициализируем emptyVerticalRowsXCoordinates
                for (placeNum = 0; placeNum < cabin.xCount; placeNum++) {
                    currentRowEmptyPlaces = 0;
                    for (rowNum = 0; rowNum < cabin.yCount; rowNum++) {
                        if (cabin.tableRows[rowNum][placeNum].isEmptyCell) {
                            currentRowEmptyPlaces++;
                        }
                    }
                    if (currentRowEmptyPlaces > amountOfPlacesInEmptyVerticalRows) {
                        amountOfPlacesInEmptyVerticalRows = currentRowEmptyPlaces;
                        emptyVerticalRowsXCoordinates = [];
                    }
                    if (currentRowEmptyPlaces == amountOfPlacesInEmptyVerticalRows) {
                        emptyVerticalRowsXCoordinates.push(placeNum);
                    }
                }

                _.each(cabin.tableRows, function (row) {
                    // В этой переменной будет номер ряда если он есть.
                    // Ряд просто может быть целиком пустым,
                    // тогда в нем вообще нет номера и его не нужно отображать.
                    var rowName = void 0;

                    _.each(row, function (cell) {
                        if (cell.rowName) {
                            rowName = cell.rowName;
                        }
                    });

                    if (rowName) {
                        _.each(emptyVerticalRowsXCoordinates, function (x) {
                            row[x].label = rowName;
                        });
                    }
                });
            });
        }

        data.hasFreeAvailableSeats = checkFreeAvailableSeats(data.cabins);
        data.hasBabyBassinet = checkBabyBassinet(data.cabins);
        data.hasUncomfortable = checkUncomfortable(data.cabins);
        data.hasEmergencyExit = checkEmergencyExit(data.cabins);
        data.availableRfiscs = getViewCraftAvailableRfiscs(data.cabins);
        data.svcs = getViewCraftSvcs(data.cabins);

        return data;
    }

    function checkBabyBassinet(cabins) {
        if (cabins && cabins.length) {
            for (var i = 0; i < cabins.length; i++) {
                for (var j = 0; j < cabins[i].places.length; j++) {
                    if (cabins[i].places[j].babyBassinet) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    function checkUncomfortable(cabins) {
        if (cabins && cabins.length) {
            for (var i = 0; i < cabins.length; i++) {
                for (var j = 0; j < cabins[i].places.length; j++) {
                    if (cabins[i].places[j].uncomfortable) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    function checkFreeAvailableSeats(cabins) {
        if (cabins && cabins.length) {
            for (var i = 0; i < cabins.length; i++) {
                for (var j = 0; j < cabins[i].places.length; j++) {
                    if (cabins[i].places[j].available && (!cabins[i].places[j].rate || !cabins[i].places[j].rate.value)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    function checkEmergencyExit(cabins) {
        if (cabins && cabins.length) {
            for (var i = 0; i < cabins.length; i++) {
                for (var j = 0; j < cabins[i].places.length; j++) {
                    if (cabins[i].places[j].type === 'SEAT_NEAR_EMERGENCY_EXIT') {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    function getViewCraftAvailableRfiscs(cabins) {
        var list = [];
        if (cabins && cabins.length) {
            for (var i = 0; i < cabins.length; i++) {
                for (var j = 0; j < cabins[i].places.length; j++) {
                    if (cabins[i].places[j].rfisc && cabins[i].places[j].available && !utils.hasInList(list, cabins[i].places[j].rfisc)) {
                        list.push(cabins[i].places[j].rfisc);
                    }
                }
            }
        }
        return list;
    }

    function getViewCraftSvcs(cabins) {
        var list = [];
        if (cabins && cabins.length) {
            for (var i = 0; i < cabins.length; i++) {
                for (var j = 0; j < cabins[i].places.length; j++) {
                    var _cabins$i$places$j = cabins[i].places[j],
                        rfisc = _cabins$i$places$j.rfisc,
                        rate = _cabins$i$places$j.rate,
                        available = _cabins$i$places$j.available,
                        customProperties = _cabins$i$places$j.customProperties;

                    var alreadyExistSvc = _.findWhere(list, { rfisc: rfisc });
                    if (rfisc && available && !alreadyExistSvc) {
                        list.push({
                            rfisc: rfisc,
                            customProperties: customProperties,
                            cost: rate.value,
                            currency: rate.currencyCode
                        });
                    }
                }
            }
        }
        return list;
    }

    function reformatConfirmCheckin(data) {
        if (data.extraServicesPayment) {
            var esp = angular.copy(data.extraServicesPayment);
            data.extraServicesPayment = reformatExtraServicesPayment(esp);
            data.extraServicesToRemoveIds = getExtraServicesToRemoveIds(esp);
        }
        return data;
    }

    function checkTabIdParam() {
        var tabIdParam = utils.getParamFromLocation('tabId');
        return !tabIdParam || tabIdParam === uniqueTabIdGenerator();
    }

    function fetchJSON(url, method, data, settings) {

        if (o2context.jsonMocks && o2context.jsonMocks[url]) {
            url = o2context.jsonMocks[url];
        }

        var requestPromise = $q(function (resolve, reject) {

            $http({
                method: method || 'GET',
                data: data,
                url: url,
                timeout: settings && settings.timeout,
                headers: {
                    'Unique-Tab-Id': uniqueTabIdGenerator()
                }
            }).then(function (resp) {
                if (resp.data) {
                    resp.data = utils.deepDecodeQuot(resp.data);
                    if (resp.data.error) {
                        handleError(resp.data);
                    } else if (resp.data.cancelSession) {
                        reject({ error: 'cancelSession' });
                        clearSession().then(function () {
                            if (cancelSessionHandler) {
                                cancelSessionHandler();
                            }
                        });
                    } else {
                        resolve(resp.data);
                    }
                } else {
                    handleError({ error: 'oxygen-check-in.messages.defaultError' });
                }
            }, function (resp) {
                var errCode = 'oxygen-check-in.messages.defaultError';
                if (resp.status === -1) {
                    errCode = 'oxygen-check-in.messages.httpAbort';
                }
                handleError({ error: errCode });
            });

            function handleError(resp) {
                if (!settings || !settings.ignoreError) {
                    $rootScope.globalError = resp.error;
                }
                reject(resp);
            }
        });

        if (settings && settings.keyEvent) {
            watchman.notify({
                name: settings.keyEvent,
                type: 'request',
                data: data
            });
            requestPromise.then(overlooker, overlooker);
        }

        return requestPromise;

        function overlooker(resp) {
            watchman.notify({
                name: settings.keyEvent,
                type: 'response',
                data: resp
            });
            return resp;
        }
    }

    function reformatExtraServicesPayment(esp) {
        return {
            servicesToPayFor: [].concat((0, _toConsumableArray3.default)(setGroupCode(esp.allAeroexpressToPayFor, 'aeroexpress')), (0, _toConsumableArray3.default)(setGroupCode(esp.allRegularInsuranceToPayFor, 'insurance')), (0, _toConsumableArray3.default)(setGroupCode(esp.allOnlineInsuranceToPayFor, 'insurance')), (0, _toConsumableArray3.default)(esp.svcsToPayFor)),
            servicesToRemove: [].concat((0, _toConsumableArray3.default)(setGroupCode(esp.allAeroexpressToRemove, 'aeroexpress')), (0, _toConsumableArray3.default)(setGroupCode(esp.allRegularInsuranceToRemove, 'insurance')), (0, _toConsumableArray3.default)(setGroupCode(esp.allOnlineInsuranceToRemove, 'insurance')), (0, _toConsumableArray3.default)(esp.svcsToRemove)),
            servicesToRemoveIdWithReasons: [].concat((0, _toConsumableArray3.default)(setGroupCode(esp.aeroexpressToRemoveIdWithReasons, 'aeroexpress')), (0, _toConsumableArray3.default)(setGroupCode(esp.regularInsuranceToRemoveIdWithReasons, 'insurance')), (0, _toConsumableArray3.default)(setGroupCode(esp.onlineInsuranceToRemoveIdWithReasons, 'insurance')), (0, _toConsumableArray3.default)(esp.svcToRemoveIdWithReasons)),
            priceToPay: esp.priceToPay,
            priceToPayCurrency: esp.priceToPayCurrency,
            priceForServicesToRemove: esp.priceForServicesToRemove,
            priceForServicesToRemoveCurrency: esp.priceForServicesToRemoveCurrency
        };
        function setGroupCode(list, groupCode) {
            return list.map(function (item) {
                item.groupCode = groupCode;
                return item;
            });
        }
    }

    function getExtraServicesToRemoveIds(esp) {
        return {
            aeroexpressToRemoveIds: getIds(esp.allAeroexpressToRemove),
            regularInsuranceToRemoveIds: getIds(esp.allRegularInsuranceToRemove),
            onlineInsuranceToRemoveIds: getIds(esp.allOnlineInsuranceToRemove),
            svcToRemoveIds: getIds(esp.svcsToRemove)
        };
        function getIds(list) {
            return list.map(function (item) {
                return item.id;
            });
        }
    }

    function setCancelSessionHandler(fn) {
        cancelSessionHandler = fn;
    }
}]);

},{"babel-runtime/helpers/toConsumableArray":6}],85:[function(require,module,exports){
"use strict";

require('./backend');
require('./utils');
require('./uniqueTabIdGenerator');
require('./watchman');

},{"./backend":84,"./uniqueTabIdGenerator":86,"./utils":87,"./watchman":88}],86:[function(require,module,exports){
"use strict";

angular.module('app').factory('uniqueTabIdGenerator', ['$window', function ($window) {

    var ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
        TAB_ID_LENGTH = 32;

    return getTabId;

    function getTabId() {
        try {
            return $window.sessionStorage.UNIQUE_TAB_ID || generateNewId();
        } catch (err) {
            return 'NONE';
        }
    }

    function generateNewId() {
        var timestamp = new Date().getTime().toString(),
            randomString = randomBase64(TAB_ID_LENGTH - timestamp.length),
            tabId = timestamp + randomString;
        $window.sessionStorage.UNIQUE_TAB_ID = tabId;
        return tabId;
    }

    function randomBase64(length) {
        var str = '',
            rand = void 0;
        for (var i = 0; i < length; ++i) {
            rand = Math.floor(Math.random() * ALPHABET.length);
            str += ALPHABET.substring(rand, rand + 1);
        }
        return str;
    }
}]);

},{}],87:[function(require,module,exports){
"use strict";

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').factory('utils', ['$window', function ($window) {

    var service = {
        hasInList: hasInList,
        deepDecodeQuot: deepDecodeQuot,
        getParamFromLocation: getParamFromLocation,
        checkSegmentWillBeOpened: checkSegmentWillBeOpened,
        formatPrice: formatPrice,
        capitalize: capitalize,
        capitalizeFirstLetter: capitalizeFirstLetter,
        isCommonServiceCode: isCommonServiceCode,
        reformatAvailableExtraServices: reformatAvailableExtraServices,
        reformatAvailableExtraServicesByCards: reformatAvailableExtraServicesByCards,
        getAvailableExtraServicesList: getAvailableExtraServicesList,
        groupSvcsByFlightPassenger: groupSvcsByFlightPassenger,
        groupInsuranceItemsPassengers: groupInsuranceItemsPassengers,
        groupInsuranceItemsFlightPassengers: groupInsuranceItemsFlightPassengers,
        getFirstAvailableSvcsFlight: getFirstAvailableSvcsFlight,
        getFirstAvailableSvcsPassenger: getFirstAvailableSvcsPassenger,
        markInsuranceOnline: markInsuranceOnline,
        getDocumentsAndFFP: getDocumentsAndFFP,
        createOptionsForUiSelect: createOptionsForUiSelect,
        suffixCount: suffixCount,
        getFirstNotEmptySubListItem: getFirstNotEmptySubListItem,
        calcAge: calcAge,
        isDateInPeriod: isDateInPeriod,
        compareStringDate: compareStringDate,
        compareStringTime: compareStringTime,
        getViewedServices: getViewedServices,
        getViewedServicesItems: getViewedServicesItems,
        getRemovedServices: getRemovedServices,
        addViewedService: addViewedService,
        addViewedServiceItem: addViewedServiceItem,
        addRemovedService: addRemovedService,
        clearServicesStatistics: clearServicesStatistics,
        hasSelectedPassengers: hasSelectedPassengers
    };
    var decCache = [];
    var decCases = [2, 0, 1, 1, 1, 2];

    return service;

    function hasInList(list, item) {
        var i = void 0;
        if (list && item !== undefined) {
            for (i = 0; i < list.length; i++) {
                if (list[i] == item) {
                    return true;
                }
            }
        }
        return false;
    }

    function deepDecodeQuot(data) {
        var key = void 0;
        if ((typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object') {
            for (key in data) {
                if (data.hasOwnProperty(key)) {
                    data[key] = deepDecodeQuot(data[key]);
                }
            }
            return data;
        } else if (typeof data === 'string') {
            return data.replace(/&quot;/g, '"');
        } else {
            return data;
        }
    }

    function getParamFromLocation(name) {
        var location = $window.location;
        var isName = new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)').exec(location.search);
        if (isName) {
            return decodeURIComponent(isName[1]);
        }
    }

    function checkSegmentWillBeOpened(checkinOpenDate) {
        var checkinOpenMoment = moment(checkinOpenDate, 'DD.MM.YYYY HH:mm');
        var serverMoment = moment(o2context.serverDateTime);
        return checkinOpenMoment.diff(serverMoment) >= 0;
    }

    function getUnicodeCurrencySign(currencyCode) {
        var signs = {
            'РУБ': '&#8381;',
            'RUB': '&#8381;',
            'THB': '&#3647;',
            'CRC': '&#8353;',
            'GHC': '&#8373;',
            'VND': '&#8363;',
            'EUR': '&#8364;',
            'GBP': '&#163;',
            'TRY': '&#8356;',
            'TRL': '&#8356;',
            'PYG': '&#8370;',
            'LAK': '&#8365;',
            'NGN': '&#8358;',
            'ARS': '&#8369;',
            'CLP': '&#8369;',
            'COP': '&#8369;',
            'CUP': '&#8369;',
            'PHP': '&#8369;',
            'UYU': '&#8369;',
            'CUC': '&#8369;',
            'ARA': '&#8369;',
            'MXN': '&#8369;',
            'USD': '&#36;',
            'MNT': '&#8366;',
            'KRW': '&#8361;',
            'KPW': '&#8361;',
            'JPY': '&#165;',
            'UAH': '&#8372;',
            'KZT': '&#8376;',
            'KHR': '&#6107;',
            'YER': '&#65020;',
            'IRR': '&#65020;',
            'OMR': '&#65020;',
            'QAR': '&#65020;',
            'INR': '&#8377;',
            'GEL': '&#8382;',
            'BYN': '&#66;&#114;',
            'БЫН': '&#66;&#114;'
        };
        return signs[currencyCode] || '';
    }

    function formatPrice(input) {

        var value = input.value;
        var currency = input.currency || 'RUB';
        var unicodeCurrencySign = getUnicodeCurrencySign(currency);
        var currencyStr = currency;

        if (unicodeCurrencySign !== '') {
            currencyStr = '<span class="currency-sign">' + unicodeCurrencySign + '</span>';
        }

        if (!value && value !== 0) {
            if (input.ignoreEmptyValue) {
                return currencyStr;
            } else {
                return '';
            }
        } else {
            return formatPriceNum(value) + currencyStr;
        }
    }

    function formatPriceNum(num) {
        var str = Big(num).toFixed(2),
            resultStr = '',
            from = void 0,
            to = void 0;

        var paths = str.split('.');

        str = paths[0];

        for (var i = str.length; i > 0; i -= 3) {
            from = i - 3;
            to = 3;

            if (from < 0) {
                to = from + 3;
                from = 0;
            }

            resultStr = str.substr(from, to) + ' ' + resultStr;
        }

        if (paths[1] && paths[1] !== "0" && paths[1] !== "00") {
            if (paths[1].length === 1) {
                paths[1] = paths[1] + '0';
            }

            resultStr = resultStr.trim() + '.' + paths[1] + ' ';
        }

        resultStr = resultStr.replace(/\s/g, "&nbsp;");

        return resultStr;
    }

    function capitalize(string) {
        string = String(string).toLowerCase();
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function capitalizeFirstLetter(string) {
        return String(string).charAt(0).toUpperCase() + string.slice(1);
    }

    function isCommonServiceCode(code) {
        return code !== 'seat' && code !== 'baggage' && code !== 'meal' && code !== 'gateMeal' && code !== 'insurance' && code !== 'insuranceOnline' && code !== 'aeroexpress';
    }

    function reformatAvailableExtraServices(availableExtraServices, orderInfo, oldES) {

        var es = {};

        availableExtraServices.map(markInsuranceOnline).forEach(function (service) {

            var editablePrice = orderInfo.sirenaOrder.pricesEditable && orderInfo.sirenaOrder.pricesEditable.totalExtraServiceByGroup[service.code] ? {
                price: orderInfo.sirenaOrder.pricesEditable.totalExtraServiceByGroup[service.code],
                currency: orderInfo.sirenaOrder.pricesEditable.currency
            } : false;

            if (service.code === 'insurance') {
                if (service.items && service.items.length) {
                    es.insurance = {
                        code: 'insurance',
                        active: editablePrice || oldES && oldES.insurance && oldES.insurance.active,
                        editablePrice: editablePrice,
                        items: service.items,
                        itemsBySegmentsPassengers: getInsuranceItemsBySegmentsPassengers(angular.copy(service.items), orderInfo.sirenaOrder.passengers, orderInfo.sirenaOrder.segments),
                        fullPrice: getInsuranceFullPrice(service, orderInfo.sirenaOrder.passengers.length),
                        onlineMode: service.onlineMode || false
                    };
                    if (es.insurance.itemsBySegmentsPassengers) {
                        setActiveInsuranceItemsStateBySegmentsPassengers(es.insurance.itemsBySegmentsPassengers, orderInfo.sirenaOrder, service.onlineMode);
                    }
                    if (es.insurance.items) {
                        setActiveInsuranceItemsState(es.insurance.items, orderInfo.sirenaOrder, service.onlineMode);
                    }
                }
            } else if (service.code === 'aeroexpress') {
                /* jshint maxlen: 150 */
                es.aeroexpress = {
                    code: 'aeroexpress',
                    active: editablePrice || oldES && oldES.aeroexpress && oldES.aeroexpress.active || service.autoExpand,
                    editablePrice: editablePrice,
                    optimal: reformatAeroexpressOptimal(service.optimal),
                    faresList: getAeroexpressFaresList(service.items)
                };
                es.aeroexpress.items = service.items;
                es.aeroexpress.documents = service.documents;
                es.aeroexpress.passengerFirstNameRegexp = service.passengerFirstNameRegexp;
                es.aeroexpress.passengerLastNameRegexp = service.passengerLastNameRegexp;
                es.aeroexpress.minPrice = getServiceMinPrice({ items: es.aeroexpress.items });
                es.aeroexpress.routes = getAeroexpressRoutes(service);
                es.aeroexpress.routesList = _.keys(es.aeroexpress.routes);
            } else if (service.code === 'meal') {

                es.meal = {
                    code: 'meal',
                    active: !!(editablePrice || oldES && oldES.meal && oldES.meal.active || service.autoExpand),
                    defaultSelected: service.defaultSelected || false,
                    editablePrice: editablePrice,
                    itemsByPassengerSegments: getItemsByPassengerSegments(orderInfo, service),
                    availableByPassengerSegments: getAvailableByPassengerSegments(orderInfo, service),
                    subgroups: service.structure.subgroups.map(function (subgroup) {
                        return subgroup.code;
                    }),
                    minPrice: getServiceMinPrice(service),
                    pricesByPassengerSegments: getCommonServicePricesByPassengerSegments(orderInfo, 'meal')
                };

                es.meal.availableBySegments = getAvailableBySegments(es.meal.availableByPassengerSegments);
            } else if (service.code === 'baggage') {

                es.baggage = {
                    code: 'baggage',
                    active: !!(editablePrice || oldES && oldES.baggage && oldES.baggage.active || service.autoExpand),
                    editablePrice: editablePrice,
                    itemsByPassengerSegments: getItemsByPassengerSegments(orderInfo, service),
                    availableByPassengerSegments: getAvailableByPassengerSegments(orderInfo, service),
                    pricesByPassengers: getBaggagePricesByPassengers(orderInfo),
                    pricesByPassengerSegments: getCommonServicePricesByPassengerSegments(orderInfo, 'baggage'),
                    minPrice: getServiceMinPrice(service),
                    subgroups: service.structure.subgroups,
                    routeParts: generateServiceRouteParts(service, orderInfo)
                };

                es.baggage.availableBySegments = getAvailableBySegments(es.baggage.availableByPassengerSegments);
            } else if (service.code === 'divingEquipment') {

                es.divingEquipment = {
                    code: 'divingEquipment',
                    active: !!(editablePrice || oldES && oldES.divingEquipment && oldES.divingEquipment.active || service.autoExpand),
                    editablePrice: editablePrice,
                    itemsByPassengerSegments: getItemsByPassengerSegments(orderInfo, service),
                    availableByPassengerSegments: getAvailableByPassengerSegments(orderInfo, service),
                    pricesByPassengers: getBaggagePricesByPassengers(orderInfo),
                    pricesByPassengerSegments: getCommonServicePricesByPassengerSegments(orderInfo, 'divingEquipment'),
                    minPrice: getServiceMinPrice(service),
                    subgroups: service.structure.subgroups,
                    routeParts: generateServiceRouteParts(service, orderInfo)
                };

                es.divingEquipment.availableBySegments = getAvailableBySegments(es.divingEquipment.availableByPassengerSegments);
            } else {
                es[service.code] = getCommonServiceInfo(orderInfo, oldES, service);
            }
        });

        return es;
    }

    function reformatAvailableExtraServicesByCards() {
        var availableExtraServices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var orderInfo = arguments[1];
        var oldES = arguments[2];

        var es = {};
        if (orderInfo) {
            availableExtraServices.map(markInsuranceOnline).forEach(function (availableExtraService) {
                var code = availableExtraService.code,
                    autoExpand = availableExtraService.autoExpand,
                    passengers = availableExtraService.passengers,
                    structure = availableExtraService.structure;

                var editablePrice = false;
                if (orderInfo.pricesEditable && orderInfo.pricesEditable.totalExtraServiceByGroup[code]) {
                    editablePrice = {
                        price: orderInfo.pricesEditable.totalExtraServiceByGroup[code],
                        currency: orderInfo.pricesEditable.currency
                    };
                }

                var svcs = [];

                if (passengers && passengers.length) {
                    passengers.forEach(function (passenger) {
                        if (passenger.segments && passenger.segments.length) {
                            passenger.segments.forEach(function (segment) {
                                if (segment.availableExtraServices && segment.availableExtraServices.length) {
                                    segment.availableExtraServices.forEach(function (subgroup, subgroupNum) {
                                        if (subgroup && subgroup.length) {
                                            subgroup.forEach(function (item) {
                                                svcs.push((0, _extends3.default)({}, item, {
                                                    passengerId: passenger.id,
                                                    pnr: passenger.pnr,
                                                    segmentId: segment.id,
                                                    groupCode: code,
                                                    subgroupCode: structure.subgroups[subgroupNum].code
                                                }));
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                }

                if (svcs.length) {

                    var uniqueServices = [].concat((0, _toConsumableArray3.default)(new Set(svcs.map(function (svc) {
                        return svc.rfisc;
                    }))));
                    svcs.forEach(function (availableSvc) {
                        var selectedSvc = _.findWhere(orderInfo.editableExtraServicesHeap, {
                            groupCode: availableSvc.groupCode,
                            passengerId: availableSvc.passengerId,
                            pnr: availableSvc.pnr,
                            mainSegmentId: availableSvc.segmentId,
                            rfisc: availableSvc.rfisc
                        });
                        if (selectedSvc) {
                            if (selectedSvc.amount) {
                                availableSvc.alreadySelectedCount = selectedSvc.amount;
                            }
                            if (selectedSvc.extraProperties) {
                                availableSvc.extraProperties = selectedSvc.extraProperties;
                            }
                            if (selectedSvc.totalPrice) {
                                availableSvc.alreadySelectedPrice = selectedSvc.totalPrice;
                            }
                            if (selectedSvc.value) {
                                availableSvc.alreadySelectedValue = selectedSvc.value;
                            }
                            if (selectedSvc.currency) {
                                availableSvc.currency = selectedSvc.currency;
                            }
                        }
                    });

                    es[code] = (0, _extends3.default)({}, availableExtraService, {
                        active: autoExpand || oldES && oldES[code] && oldES[code].active,
                        editablePrice: editablePrice,
                        minPrice: !!availableExtraService.showMinPrice && getServiceMinPrice(availableExtraService),
                        svcs: svcs,
                        cards: uniqueServices.map(function (rfisc) {
                            var rfiscSvcs = svcs.filter(function (svc) {
                                return svc.rfisc === rfisc;
                            });
                            return {
                                rfisc: rfisc,
                                svcs: rfiscSvcs,
                                alreadySelectedPrice: calcAlreadySelectedPriceBySvcs(rfiscSvcs),
                                alreadySelectedByValue: calcAlreadySelectedByValueBySvcs(rfiscSvcs)
                            };
                        })
                    });
                } else if (code === 'insurance') {
                    es.insurance = (0, _extends3.default)({}, availableExtraService, {
                        active: autoExpand || oldES && oldES[code] && oldES[code].active,
                        editablePrice: editablePrice,
                        minPrice: !!availableExtraService.showMinPrice && getServiceMinPrice(availableExtraService),
                        fullPrice: getInsuranceFullPrice(availableExtraService, orderInfo.passengers.length),
                        onlineMode: availableExtraService.onlineMode || false,
                        cards: []
                    });
                    if (es.insurance.items) {
                        setActiveInsuranceCardItems(es.insurance.items, orderInfo, availableExtraService.onlineMode);
                        es.insurance.items.forEach(function (item) {
                            var itemCard = _.findWhere(es.insurance.cards, {
                                ins: item.ins,
                                tins: item.tins,
                                productCode: item.productCode
                            });
                            if (itemCard) {
                                itemCard.items.push(item);
                                itemCard.alreadySelectedPrice = calcAlreadySelectedPriceByInsuranceItems(itemCard.items, orderInfo.passengers.length);
                            } else {
                                var insTinsProductCode = [item.ins, item.tins, item.productCode];
                                var itemId = insTinsProductCode.join('.');
                                var imageName = insTinsProductCode.join('_');
                                var productType = item.productCode ? 'insuranceOnline' : 'insurance';
                                var nameAlias = 'oxygen-check-in.' + productType + '.' + itemId;
                                var descAlias = 'oxygen-check-in.' + productType + '.currentRules.' + itemId;
                                var shortDescAlias = 'oxygen-check-in.' + productType + '.shortCurrentRules.' + itemId;
                                var vendorImage = 'insurance-vendors/' + imageName + '.svg';
                                var promoImage = 'insurance-products/' + imageName + '.jpeg';
                                var promoLogo = 'insurance-logos/' + imageName + '.svg';
                                es.insurance.cards.push({
                                    ins: item.ins,
                                    tins: item.tins,
                                    productCode: item.productCode,
                                    nameAlias: nameAlias,
                                    descAlias: descAlias,
                                    shortDescAlias: shortDescAlias,
                                    vendorImage: vendorImage,
                                    promoImage: promoImage,
                                    promoLogo: promoLogo,
                                    items: [item],
                                    alreadySelectedPrice: calcAlreadySelectedPriceByInsuranceItems([item], orderInfo.passengers.length)
                                });
                            }
                        });
                    }
                } else if (code === 'aeroexpress') {
                    es.aeroexpress = (0, _extends3.default)({}, availableExtraService, {
                        active: autoExpand || oldES && oldES[code] && oldES[code].active,
                        editablePrice: editablePrice,
                        optimal: reformatAeroexpressOptimal(availableExtraService.optimal),
                        faresList: getAeroexpressFaresList(availableExtraService.items),
                        minPrice: !!availableExtraService.showMinPrice && getAeroexpressServiceMinPrice(availableExtraService)
                    });
                    es.aeroexpress.routes = getAeroexpressRoutes(availableExtraService);
                    es.aeroexpress.routesList = _.keys(es.aeroexpress.routes);
                }
            });
        }
        return es;
    }

    function calcAlreadySelectedPriceBySvcs(svcs) {
        var alreadySelectedPrice = Big('0.00').toFixed(2);
        svcs.forEach(function (svc) {
            if (svc.alreadySelectedPrice) {
                alreadySelectedPrice = Big(alreadySelectedPrice).plus(svc.alreadySelectedPrice).toFixed(2);
            }
        });
        if (alreadySelectedPrice === '0.00') {
            return false;
        }
        return alreadySelectedPrice;
    }

    function calcAlreadySelectedByValueBySvcs(svcs) {
        var alreadySelectedByValue = {};
        svcs.forEach(function (svc) {
            if (svc.alreadySelectedValue) {
                alreadySelectedByValue[svc.alreadySelectedValue] = true;
            }
        });
        return alreadySelectedByValue;
    }

    function groupSvcsByFlightPassenger(svcs, orderInfo) {
        return deepCollapseEmptyItems(orderInfo.segments.map(function (flight) {
            return orderInfo.passengers.map(function (passenger) {
                var flightPassengerSvcs = svcs.filter(function (svc) {
                    return svc.segmentId === flight.id && svc.passengerId === passenger.id && svc.pnr === passenger.pnr;
                });
                return flightPassengerSvcs[0] || false;
            });
        }));
    }

    function groupInsuranceItemsPassengers(items, orderInfo) {
        return deepCollapseEmptyItems(orderInfo.passengers.map(function (passenger) {
            var passengerItems = (items || []).filter(function (item) {
                return item.pnr === passenger.pnr && item.passengerId === passenger.id;
            });
            if (passengerItems[0]) {
                return (0, _extends3.default)({}, passengerItems[0], {
                    limit: 1,
                    alreadySelectedCount: passengerItems[0].selected ? 1 : 0
                });
            } else {
                return false;
            }
        }));
    }

    function groupInsuranceItemsFlightPassengers(items, orderInfo) {
        return deepCollapseEmptyItems(orderInfo.segments.map(function (flight) {
            return orderInfo.passengers.map(function (passenger) {
                var passengerFlightItems = (items || []).filter(function (item) {
                    return item.pnr === passenger.pnr && item.passengerId === passenger.id && item.segmentId === flight.id;
                });
                if (passengerFlightItems[0]) {
                    return (0, _extends3.default)({}, passengerFlightItems[0], {
                        limit: 1,
                        alreadySelectedCount: passengerFlightItems[0].selected ? 1 : 0
                    });
                } else {
                    return false;
                }
            });
        }));
    }

    function deepCollapseEmptyItems(list) {
        if (list.some(function (item) {
            return !!item;
        })) {
            return list.map(function (item) {
                return item.length ? deepCollapseEmptyItems(item) : item;
            });
        } else {
            return false;
        }
    }

    function getFirstAvailableSvcsFlight(svcs, orderInfo) {
        var _loop = function _loop(i) {
            if (svcs.some(function (svc) {
                return svc.segmentId === orderInfo.segments[i].id;
            })) {
                return {
                    v: i
                };
            }
        };

        for (var i = 0; i < orderInfo.segments.length; i++) {
            var _ret = _loop(i);

            if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
        }
        return -1;
    }

    function getFirstAvailableSvcsPassenger(svcs, orderInfo, flightIndex) {
        var _loop2 = function _loop2(i) {
            if (svcs.some(function (svc) {
                return svc.segmentId === orderInfo.segments[flightIndex].id && svc.passengerId === orderInfo.passengers[i].id;
            })) {
                return {
                    v: i
                };
            }
        };

        for (var i = 0; i < orderInfo.passengers.length; i++) {
            var _ret2 = _loop2(i);

            if ((typeof _ret2 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret2)) === "object") return _ret2.v;
        }
        return -1;
    }

    function getAeroexpressFaresList(items) {
        var fareCodes = {};
        var faresList = [];
        items.forEach(function (item) {
            if (!fareCodes[item.fare]) {
                fareCodes[item.fare] = true;
                faresList.push({
                    code: item.fare,
                    type: item.fare_type,
                    description: item.description,
                    cost: item.cost,
                    currency: item.currency
                });
            }
        });
        return faresList;
    }

    function getInsuranceItemsBySegmentsPassengers(items, passengers, flights) {
        if (items.some(function (item) {
            return item.passengerId !== undefined;
        }) && items.some(function (item) {
            return item.segmentId !== undefined;
        })) {
            return flights.map(function (flight) {
                var itemsByPassengerSegment = passengers.map(function (passenger) {
                    return items.filter(function (item) {
                        return item.pnr === passenger.pnr && item.passengerId === passenger.id && item.segmentId === flight.id;
                    });
                });
                return itemsByPassengerSegment.length ? itemsByPassengerSegment : false;
            });
        } else {
            return false;
        }
    }

    function getInsuranceFullPrice(service, count) {
        var i = 0,
            min = void 0,
            minCurrency = void 0,
            currentItemPrice = void 0;
        if (!service.items || !service.items[0]) {
            return;
        }
        while (i < service.items.length) {
            currentItemPrice = service.items[i].price || Big(service.items[i].insurance_premium || 0).plus(service.items[i].luggage_premium || 0).times(count).toFixed(2);
            if (!min || min.gt(currentItemPrice)) {
                min = Big(currentItemPrice);
                minCurrency = service.items[i].currency;
            }
            i++;
        }
        return {
            price: min.toFixed(2),
            currency: minCurrency
        };
    }

    function setActiveInsuranceItemsStateBySegmentsPassengers(itemsBySegmentsPassengers, orderInfo, onlineMode) {
        var editableInsuranceService = void 0,
            editableInsuranceServiceItems = void 0;

        if (orderInfo.editableExtraServices) {
            editableInsuranceService = _.findWhere(orderInfo.editableExtraServices, { code: 'insurance' });
            if (editableInsuranceService && editableInsuranceService.items && editableInsuranceService.items[0] && (editableInsuranceService.items[0][0] || onlineMode)) {
                editableInsuranceServiceItems = onlineMode ? editableInsuranceService.items : editableInsuranceService.items[0];

                editableInsuranceServiceItems.forEach(function (editableInsuranceServiceItem) {
                    orderInfo.segments.forEach(function (segment, segmentNum) {
                        orderInfo.passengers.forEach(function (passenger, passengerNum) {
                            itemsBySegmentsPassengers[segmentNum][passengerNum].forEach(function (item) {
                                if (item.ins === editableInsuranceServiceItem.ins && item.tins === editableInsuranceServiceItem.tins && item.passengerId === editableInsuranceServiceItem.passengerId && item.pnr === editableInsuranceServiceItem.pnr && item.segmentId === editableInsuranceServiceItem.segmentId && (!onlineMode || item.productCode === editableInsuranceServiceItem.productCode)) {
                                    item.selected = true;
                                }
                            });
                        });
                    });
                });
            }
        }
    }

    function setActiveInsuranceCardItems(items, orderInfo, onlineMode) {
        var editableInsuranceService = void 0,
            editableInsuranceServiceItems = void 0;

        if (orderInfo.editableExtraServices) {
            editableInsuranceService = _.findWhere(orderInfo.editableExtraServices, { code: 'insurance' });
            if (editableInsuranceService && editableInsuranceService.items && editableInsuranceService.items[0] && (editableInsuranceService.items[0][0] || onlineMode)) {
                editableInsuranceServiceItems = onlineMode ? editableInsuranceService.items : editableInsuranceService.items[0];

                editableInsuranceServiceItems.forEach(function (editableInsuranceServiceItem) {
                    items.forEach(function (item) {
                        if (item.ins === editableInsuranceServiceItem.ins && item.tins === editableInsuranceServiceItem.tins && (!item.passengerId || item.passengerId === editableInsuranceServiceItem.passengerId) && (!item.pnr || item.pnr === editableInsuranceServiceItem.pnr) && (!item.segmentId || item.segmentId === editableInsuranceServiceItem.segmentId) && (!onlineMode || item.productCode === editableInsuranceServiceItem.productCode)) {
                            item.selected = true;
                        }
                    });
                });
            }
        }
    }

    function calcAlreadySelectedPriceByInsuranceItems(items, paxCount) {
        var alreadySelectedPrice = Big('0.00').toFixed(2);
        items.forEach(function (item) {
            if (item.selected) {
                if (item.price) {
                    alreadySelectedPrice = Big(alreadySelectedPrice).plus(item.price).toFixed(2);
                }
                if (item.insurance_premium || item.luggage_premium) {
                    alreadySelectedPrice = Big(alreadySelectedPrice).plus(Big(item.insurance_premium || 0).plus(item.luggage_premium || 0).times(paxCount)).toFixed(2);
                }
            }
        });
        if (alreadySelectedPrice === '0.00') {
            return false;
        }
        return alreadySelectedPrice;
    }

    function getAeroexpressServiceMinPrice(service) {
        if (!service.items.length) {
            return false;
        }
        return {
            price: getMinPrice(service.items.map(function (serviceItem) {
                return serviceItem.cost;
            })),
            currency: service.items[0].currency
        };
    }

    function setActiveInsuranceItemsState(items, orderInfo, onlineMode) {
        var editableInsuranceService = void 0,
            editableInsuranceServiceItem = void 0;
        if (orderInfo.editableExtraServices) {
            editableInsuranceService = _.findWhere(orderInfo.editableExtraServices, { code: 'insurance' });
            if (editableInsuranceService && editableInsuranceService.items && editableInsuranceService.items[0] && (editableInsuranceService.items[0][0] || onlineMode)) {
                editableInsuranceServiceItem = onlineMode ? editableInsuranceService.items[0] : editableInsuranceService.items[0][0];
                items.forEach(function (item) {
                    if (item.ins === editableInsuranceServiceItem.ins && item.tins === editableInsuranceServiceItem.tins && (!onlineMode || item.productCode === editableInsuranceServiceItem.productCode)) {
                        item.selected = true;
                    }
                });
            }
        }
    }

    function getCommonServiceInfo(orderInfo, oldES, service) {

        var editablePrice = orderInfo.sirenaOrder.pricesEditable && orderInfo.sirenaOrder.pricesEditable.totalExtraServiceByGroup[service.code] ? {
            price: orderInfo.sirenaOrder.pricesEditable.totalExtraServiceByGroup[service.code],
            currency: orderInfo.sirenaOrder.pricesEditable.currency
        } : false;

        return {
            code: service.code,
            active: !!(editablePrice || oldES && oldES[service.code] && oldES[service.code].active),
            iconCode: service.iconCode || 'none',
            defaultSelected: service.defaultSelected || false,
            showMinPrice: service.showMinPrice || false,
            itemsByPassengerSegments: getItemsByPassengerSegments(orderInfo, service),
            pricesByPassengerSegments: getCommonServicePricesByPassengerSegments(orderInfo, service.code),
            minPrice: getServiceMinPrice(service),
            editablePrice: editablePrice,
            subgroups: service.structure.subgroups.map(function (subgroup) {
                return subgroup.code;
            }),
            routeParts: generateServiceRouteParts(service, orderInfo)
        };
    }

    function reformatAeroexpressOptimal(optimal) {
        if (optimal && optimal.dates) {
            optimal.dateVariants = optimal.dates.map(function (date) {
                return date.date;
            });
        }
        return optimal;
    }

    function getAeroexpressRoutes(service) {
        var routes = {};
        service.items.forEach(function (item) {
            var routeCode = item.departure_code + item.arrival_code;
            if (!routes[routeCode]) {
                routes[routeCode] = {
                    departure_code: item.departure_code,
                    arrival_code: item.arrival_code,
                    departure_name: item.departure_name,
                    arrival_name: item.arrival_name,
                    directionType: item.directionType,
                    dateVariants: {},
                    dateVariantsList: []
                };
            }
            if (!routes[routeCode].dateVariants[item.date]) {
                routes[routeCode].dateVariants[item.date] = {
                    preferredDate: item.preferredDate,
                    fares: [],
                    freeRideRange: getFreeAeroexpressRideRange(service.economyFreeRidesInfo, item.date)
                };
                routes[routeCode].dateVariantsList.push(item.date);
            }
            routes[routeCode].dateVariants[item.date].fares.push({
                description: item.description,
                fare: item.fare,
                fare_type: item.fare_type,
                cost: item.cost,
                currency: item.currency,
                birthdayRange: item.birthdayRange
            });
        });
        return routes;
    }

    function getFreeAeroexpressRideRange(freeRideInfos, date) {
        for (var i = 0; i < freeRideInfos.length; i++) {
            if (freeRideInfos[i].departure === date) {
                return freeRideInfos[i].birthdayRange;
            }
        }
    }

    function getServiceMinPrice(service) {
        var prices = [];
        var currency = void 0;
        if (service.passengers) {
            service.passengers.forEach(function (pass) {
                pass.segments.forEach(function (passSeg) {
                    passSeg.availableExtraServices.forEach(function (subgroup) {
                        subgroup.forEach(function (serviceItem) {
                            if (!currency && serviceItem.currency) {
                                currency = serviceItem.currency;
                            }
                            if (serviceItem.price) {
                                prices.push(serviceItem.price);
                            }
                        });
                    });
                });
            });
        } else if (service.items) {
            service.items.forEach(function (serviceItem) {
                if (!currency && serviceItem.currency) {
                    currency = serviceItem.currency;
                }
                if (serviceItem.price) {
                    prices.push(serviceItem.price);
                }
            });
        }
        if (!prices.length || !currency) {
            return false;
        }
        return {
            price: getMinPrice(prices),
            currency: currency
        };
    }

    function getMinPrice(prices) {
        var i = 0,
            min = void 0;
        while (i < prices.length) {
            if (!min || min.gt(prices[i])) {
                min = Big(prices[i]);
            }
            i++;
        }
        if (!min) {
            return false;
        }
        return min.toFixed(2);
    }

    function getItemsByPassengerSegments(orderInfo, service) {
        var orderEditableService = _.findWhere(orderInfo.sirenaOrder.editableExtraServices, { code: service.code });
        return orderInfo.sirenaOrder.passengers.map(function (orderPassenger) {
            var servicePassenger = _.findWhere(service.passengers, {
                id: orderPassenger.id,
                pnr: orderPassenger.pnr
            });
            if (!servicePassenger) {
                return false;
            }
            return orderInfo.sirenaOrder.segments.map(function (orderSegment) {
                var servicePassengerSegment = _.findWhere(servicePassenger.segments, { id: orderSegment.id });
                var orderEditableServicePassenger = orderEditableService && _.findWhere(orderEditableService.passengers, {
                    id: orderPassenger.id,
                    pnr: orderPassenger.pnr
                });
                var orderEditableServicePassengerSegment = orderEditableServicePassenger && _.findWhere(orderEditableServicePassenger.segments, { id: orderSegment.id });
                if (servicePassengerSegment && servicePassengerSegment.availableExtraServices) {

                    // Если услуга уже есть в заказе, проставим alreadySelectedCount
                    if (orderEditableServicePassengerSegment && orderEditableServicePassengerSegment.selectedExtraServices && orderEditableServicePassengerSegment.selectedExtraServices.length) {
                        // Пока будем проставлять alreadySelectedCount только для услуг с подгруппами
                        if (service.structure && service.structure.subgroups && service.structure.subgroups.length) {
                            /* jshint maxlen: 150 */
                            servicePassengerSegment.availableExtraServices.forEach(function (subgroupItems, subgroupNum) {
                                subgroupItems.forEach(function (availableServiceItem) {
                                    var selectedItem = _.findWhere(orderEditableServicePassengerSegment.selectedExtraServices, {
                                        serviceType: availableServiceItem.serviceType,
                                        rfisc: availableServiceItem.rfisc,
                                        subgroupCode: service.structure.subgroups[subgroupNum].code
                                    });
                                    if (selectedItem) {
                                        if (selectedItem.amount) {
                                            availableServiceItem.alreadySelectedCount = selectedItem.amount;
                                        }
                                        if (selectedItem.value) {
                                            availableServiceItem.value = selectedItem.value;
                                        }
                                        if (selectedItem.extraProperties) {
                                            availableServiceItem.extraProperties = selectedItem.extraProperties;
                                        }
                                        if (selectedItem.totalPrice) {
                                            availableServiceItem.alreadySelectedPrice = selectedItem.totalPrice;
                                        }
                                    }
                                });
                            });
                        }
                    }

                    return servicePassengerSegment.availableExtraServices;
                } else {
                    return false;
                }
            });
        });
    }

    function getAvailableByPassengerSegments(orderInfo, service) {
        var availableByPassengers = orderInfo.sirenaOrder.passengers.map(function (orderPassenger) {
            var servicePassenger = _.findWhere(service.passengers, {
                id: orderPassenger.id,
                pnr: orderPassenger.pnr
            });

            var hasAvailableBySegments = false;

            if (!servicePassenger) {
                return false;
            }

            var availableBySegments = orderInfo.sirenaOrder.segments.map(function (orderSegment) {
                var available = void 0;

                var servicePassengerSegment = _.findWhere(servicePassenger.segments, { id: orderSegment.id });

                if (servicePassengerSegment) {
                    available = !!getFirstNotEmptySubListItem(servicePassengerSegment.availableExtraServices);

                    if (!hasAvailableBySegments && available) {
                        hasAvailableBySegments = true;
                    }
                }

                return available;
            });

            if (!hasAvailableBySegments) {
                return false;
            }

            return availableBySegments;
        });

        var hasAvailableByPassengers = false;

        availableByPassengers.forEach(function (item) {
            if (item) {
                hasAvailableByPassengers = true;
            }
        });

        if (!hasAvailableByPassengers) {
            return false;
        }

        return availableByPassengers;
    }

    function getAvailableBySegments(availableByPassengerSegments) {
        var availableBySegments = [];

        if (!availableByPassengerSegments) {
            return availableBySegments;
        }

        availableByPassengerSegments.forEach(function (segmentsList, passengerNum) {
            if (segmentsList) {
                segmentsList.forEach(function (segmentAvailable, segmentNum) {
                    if (!passengerNum) {
                        availableBySegments.push(segmentAvailable);
                    } else {
                        if (!availableBySegments[segmentNum] && segmentAvailable) {
                            availableBySegments[segmentNum] = true;
                        }
                    }
                });
            }
        });

        return availableBySegments;
    }

    function getCommonServicePricesByPassengerSegments(orderInfo, serviceCode) {
        return orderInfo.sirenaOrder.passengers.map(function (passenger, passengerNum) {
            return orderInfo.sirenaOrder.segments.map(function (segment, segmentNum) {
                var summByPassengerSegment = Big(0);
                if (orderInfo.sirenaOrder.groupedEditableExtraServices && orderInfo.sirenaOrder.groupedEditableExtraServices[serviceCode] && orderInfo.sirenaOrder.groupedEditableExtraServices[serviceCode][passengerNum] && orderInfo.sirenaOrder.groupedEditableExtraServices[serviceCode][passengerNum][segmentNum]) {
                    /* jshint maxlen: 150 */
                    orderInfo.sirenaOrder.groupedEditableExtraServices[serviceCode][passengerNum][segmentNum].forEach(function (item) {
                        if (item.totalPrice) {
                            summByPassengerSegment = summByPassengerSegment.plus(item.totalPrice);
                        }
                    });
                }
                if (summByPassengerSegment.eq(0)) {
                    return false;
                } else {
                    return summByPassengerSegment.toFixed(2);
                }
            });
        });
    }

    function generateServiceRouteParts(service, orderInfo) {
        var routeParts = false,
            routePartsIndex = void 0;
        var allServicesHeap = [];

        if (service && service.passengers && service.passengers.length) {
            service.passengers.forEach(function (pax) {
                if (pax.segments && pax.segments.length) {
                    pax.segments.forEach(function (paxSeg) {
                        if (paxSeg.availableExtraServices && paxSeg.availableExtraServices.length) {
                            paxSeg.availableExtraServices.forEach(function (items, subgroupNum) {
                                if (items && items.length) {
                                    items.forEach(function (itemSource) {
                                        var item = angular.copy(itemSource);
                                        var itemEditable = void 0;
                                        item.passengerId = pax.id;
                                        item.subgroupNum = subgroupNum;
                                        item.subgroupCode = service.structure.subgroups[subgroupNum].code;
                                        item.mainSegmentId = paxSeg.id;
                                        if (!item.affectedSegmentIds || !item.affectedSegmentIds.length) {
                                            item.affectedSegmentIds = [paxSeg.id];
                                        }
                                        item.affectedSegmentIdsJSON = JSON.stringify(item.affectedSegmentIds.sort());
                                        item.amount = 0;
                                        if (orderInfo.editableExtraServicesHeap) {
                                            itemEditable = _.findWhere(orderInfo.editableExtraServicesHeap, {
                                                groupCode: service.code,
                                                subgroupCode: item.subgroupCode,
                                                passengerId: item.passengerId,
                                                mainSegmentId: item.mainSegmentId,
                                                rfisc: item.rfisc,
                                                serviceType: item.serviceType
                                            });
                                            if (itemEditable) {
                                                if (itemEditable.amount) {
                                                    item.amount = itemEditable.amount;
                                                }
                                                if (itemEditable.totalPrice) {
                                                    item.totalPrice = itemEditable.totalPrice;
                                                }
                                            }
                                        }
                                        allServicesHeap.push(item);
                                    });
                                }
                            });
                        }
                    });
                }
            });
        }

        if (allServicesHeap.length && orderInfo.sirenaOrder.passengers && orderInfo.sirenaOrder.passengers.length && orderInfo.sirenaOrder.segments && orderInfo.sirenaOrder.segments.length) {
            routePartsIndex = _.groupBy(allServicesHeap, 'affectedSegmentIdsJSON');
            routeParts = _.keys(routePartsIndex).map(function (key) {
                var affectedSegmentIds = JSON.parse(key);
                var mainFlightNum = void 0;
                orderInfo.sirenaOrder.segments.forEach(function (flight, num) {
                    if (flight.id === affectedSegmentIds[0]) {
                        mainFlightNum = num;
                    }
                });

                return {
                    key: key,
                    mainFlightNum: mainFlightNum,
                    flightsInfo: generateRoutePartFlightsInfo(affectedSegmentIds, orderInfo.sirenaOrder.segments),
                    availableExtraServicesByPassengersAndSubgroups: orderInfo.sirenaOrder.passengers.map(function (pax) {
                        return service.structure.subgroups.map(function (subgroup, subgroupNum) {
                            return routePartsIndex[key].filter(function (item) {
                                return item.passengerId === pax.id && item.subgroupNum === subgroupNum;
                            });
                        });
                    })
                };
            });
        }

        return routeParts;
    }

    function generateRoutePartFlightsInfo(affectedSegmentIds, segments) {
        var firstFlight = _.findWhere(segments, { id: affectedSegmentIds[0] });
        var lastFlight = _.findWhere(segments, { id: affectedSegmentIds[affectedSegmentIds.length - 1] });
        var freeBaggage = [];

        if (firstFlight && lastFlight) {

            affectedSegmentIds.forEach(function (id) {
                var flight = _.findWhere(segments, { id: id });
                if (flight && flight.baggage && flight.baggage.length) {
                    flight.baggage.forEach(function (freeBaggageItemSource) {
                        var freeBaggageItem = angular.copy(freeBaggageItemSource);
                        freeBaggageItem.racenumber = flight.racenumber;
                        freeBaggageItem.companyCode = flight.company.code;
                        freeBaggage.push(freeBaggageItem);
                    });
                }
            });

            return {
                date: firstFlight.date,
                origincityName: firstFlight.origincityName,
                origincity: firstFlight.origincity,
                originportName: firstFlight.originportName,
                originport: firstFlight.originport,
                destinationcityName: lastFlight.destinationcityName,
                destinationcity: lastFlight.destinationcity,
                destinationportName: lastFlight.destinationportName,
                destinationport: lastFlight.destinationport,
                freeBaggage: freeBaggage
            };
        }
    }

    function getBaggagePricesByPassengers(orderInfo) {
        if (orderInfo.editableExtraServicesByPassengers) {
            return orderInfo.editableExtraServicesByPassengers.map(function (item) {
                var passengerPrice = false;
                if (item && item.passengerSegmentServices) {
                    item.passengerSegmentServices.forEach(function (segment) {
                        if (segment) {
                            segment.forEach(function (service) {
                                if (service.code === 'baggage' && service.items) {
                                    service.items.forEach(function (item) {
                                        if (item.totalPrice) {
                                            passengerPrice = Big(passengerPrice || '0.00').plus(item.totalPrice).toFixed(2);
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
                return passengerPrice;
            });
        } else {
            return orderInfo.sirenaOrder.passengers.map(function () {
                return false;
            });
        }
    }

    function markInsuranceOnline(service) {
        if (service.code === 'insuranceOnline') {
            service.code = 'insurance';
            service.onlineMode = true;
        }
        return service;
    }

    function getAvailableExtraServicesList(availableExtraServices, es) {
        return availableExtraServices.map(markInsuranceOnline).filter(function (service) {
            return !!es[service.code];
        }).map(function (service) {
            return service.code;
        });
    }

    function getFirstNotEmptySubListItem(list) {
        var resultItem = void 0;

        list.forEach(function (subList) {
            if (subList.length && !resultItem) {
                subList.forEach(function (item) {
                    if (item && !resultItem) {
                        resultItem = item;
                    }
                });
            }
        });

        return resultItem;
    }

    function calcAge(dateOfBirth, flightDate) {
        var birthMoment = moment(dateOfBirth, 'DD.MM.YYYY');
        var flightMoment = moment(flightDate, 'DD.MM.YYYY');
        return flightMoment.diff(birthMoment, 'years', false);
    }

    function isDateInPeriod(date, beginDate, endDate) {
        return compareStringDate(date, beginDate) !== -1 && compareStringDate(endDate, date) !== -1;
    }

    function compareStringDate(a, b) {
        a = a.split('.');
        b = b.split('.');

        if (parseInt(a[2], 10) > parseInt(b[2], 10)) {
            return 1;
        } else if (parseInt(a[2], 10) < parseInt(b[2], 10)) {
            return -1;
        } else {
            if (parseInt(a[1], 10) > parseInt(b[1], 10)) {
                return 1;
            } else if (parseInt(a[1], 10) < parseInt(b[1], 10)) {
                return -1;
            } else {
                if (parseInt(a[0], 10) > parseInt(b[0], 10)) {
                    return 1;
                } else if (parseInt(a[0], 10) < parseInt(b[0], 10)) {
                    return -1;
                } else {
                    return 0;
                }
            }
        }
    }

    function compareStringTime(a, b) {
        a = a.split(':');
        b = b.split(':');

        if (parseInt(a[0], 10) > parseInt(b[0], 10)) {
            return 1;
        } else if (parseInt(a[0], 10) < parseInt(b[0], 10)) {
            return -1;
        } else {
            if (parseInt(a[1], 10) > parseInt(b[1], 10)) {
                return 1;
            } else if (parseInt(a[1], 10) < parseInt(b[1], 10)) {
                return -1;
            } else {
                return 0;
            }
        }
    }

    function getNameValueObj(fields) {
        var nameValueObj = {};
        _.each(fields, function (field) {
            nameValueObj[field.name] = field.value;
        });
        return nameValueObj;
    }

    function getDocumentsAndFFPbyPassenger(passenger) {
        var targetSegments = [];
        _.each(passenger.segments, function (sourceSegment) {
            var targetSegment = {
                document: getNameValueObj(sourceSegment.document.fields)
            };
            if (sourceSegment.visa && sourceSegment.visa.required) {
                if (!sourceSegment.visa.userClaimedVisaNotRequired) {
                    targetSegment.visa = getNameValueObj(sourceSegment.visa.fields);
                } else {
                    targetSegment.visaCheckboxNotRequired = true;
                }
            }
            if (sourceSegment.ffpCardNumber) {
                targetSegment.ffpCardNumber = sourceSegment.ffpCardNumber;
            }
            targetSegments.push(targetSegment);
        });
        return {
            astraVirtualId: passenger.astraVirtualId,
            segments: targetSegments
        };
    }

    function getDocumentsAndFFP(passengers) {
        var documentsAndFFP = [];
        _.each(passengers, function (passenger) {
            if (passenger.selected) {
                documentsAndFFP.push(getDocumentsAndFFPbyPassenger(passenger));
                if (passenger.child) {
                    documentsAndFFP.push(getDocumentsAndFFPbyPassenger(passenger.child));
                }
            }
        });
        return JSON.stringify(documentsAndFFP);
    }

    /**
    * Дополняем модель еще одним значением для передачи в ui-select
    * @param {array} list
    * @param {string, object} defaultValue
    * @returns {array}
    */
    function createOptionsForUiSelect(list, defaultValue) {
        return Array.isArray(list) ? createOptions(list, defaultValue) : notArray();

        function createOptions(list, defaultValue) {
            defaultValue = defaultValue === undefined ? [] : [checkTypeValue(defaultValue, false)];

            return defaultValue.concat(list.map(function (item, i) {
                return checkTypeValue(item, i);
            }));
        }

        function notArray() {
            throw new Error('In function createOptionsForUiSelect first argument should be array!');
        }

        function checkTypeValue(value, index) {
            switch (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) {
                case 'string':
                    value = createOptionFromString(value, index);
                    break;
                case 'object':
                    value = createOptionsFromObject(value, index);
                    break;
                default:
                    throw new Error('Invalid type of default value. It\'s should be string or object');
            }

            return value;
        }

        function createOptionFromString(value, index) {
            return { value: value, index: index };
        }

        function createOptionsFromObject(value, index) {
            var option = angular.copy(value);
            option.index = index;
            return option;
        }
    }

    function suffixCount(count, alias) {
        var aliasParts = String(alias).split(',');
        return count + ' ' + decOfNum(count, aliasParts);
    }

    function decOfNum(number, titles) {
        if (!decCache[number]) {
            decCache[number] = number % 100 > 4 && number % 100 < 20 ? 2 : decCases[Math.min(number % 10, 5)];
        }

        return titles[decCache[number]];
    }

    function getViewedServices() {
        return angular.fromJson($window.sessionStorage.websky_viewed_services || []);
    }

    function getViewedServicesItems() {
        return angular.fromJson($window.sessionStorage.websky_viewed_services_items || []);
    }

    function getRemovedServices() {
        return angular.fromJson($window.sessionStorage.websky_removed_services || []);
    }

    function addViewedService(code) {
        var viewedServices = getViewedServices();
        if (!hasInList(viewedServices, code)) {
            viewedServices.push(code);
            $window.sessionStorage.websky_viewed_services = angular.toJson(viewedServices);
        }
    }

    function addViewedServiceItem(code) {
        var viewedServicesItems = getViewedServicesItems();
        if (!hasInList(viewedServicesItems, code)) {
            viewedServicesItems.push(code);
            $window.sessionStorage.websky_viewed_services_items = angular.toJson(viewedServicesItems);
        }
    }

    function addRemovedService(code) {
        var removedServices = getRemovedServices();
        if (!hasInList(removedServices, code)) {
            removedServices.push(code);
            $window.sessionStorage.websky_removed_services = angular.toJson(removedServices);
        }
    }

    function clearServicesStatistics() {
        delete $window.sessionStorage.websky_viewed_services;
        delete $window.sessionStorage.websky_viewed_services_items;
        delete $window.sessionStorage.websky_removed_services;
        delete $window.sessionStorage.websky_removed_services_items;
    }

    function hasSelectedPassengers(passengers) {
        return passengers.some(function (pax) {
            return !!pax.selected;
        });
    }
}]);

},{"babel-runtime/helpers/extends":5,"babel-runtime/helpers/toConsumableArray":6,"babel-runtime/helpers/typeof":7}],88:[function(require,module,exports){
"use strict";

angular.module('app').factory('watchman', [function () {
    var listeners = [];
    var userInterfaceListeners = [];
    var orderEventsListeners = [];

    return {
        addListener: addListener,
        removeListener: removeListener,
        notify: notify,
        notifyOrderEvent: notifyOrderEvent,
        addUserInterfaceListener: addUserInterfaceListener,
        removeUserInterfaceListener: removeUserInterfaceListener,
        notifyUserInterfaceEvent: notifyUserInterfaceEvent,
        addOrderEventListener: addOrderEventListener,
        removeOrderEventListener: removeOrderEventListener
    };

    function addListener(cb) {
        if (getListenerIndex(cb, listeners) === -1) {
            return listeners.push(cb);
        }
    }

    function removeListener(cb) {
        var index = getListenerIndex(cb, listeners);
        if (getListenerIndex(cb, listeners) !== -1) {
            listeners.splice(index, 1);
        }
    }

    function notify(keyEvent) {
        listeners.forEach(function (listener) {
            try {
                listener(angular.copy(keyEvent));
            } catch (err) {
                // eslint-disable-next-line
                console.log('Error in watchman overlooker: ', err);
            }
        });
    }

    function addUserInterfaceListener(cb) {
        if (getListenerIndex(cb, userInterfaceListeners) === -1) {
            return userInterfaceListeners.push(cb);
        }
    }

    function removeUserInterfaceListener(cb) {
        var index = getListenerIndex(cb, userInterfaceListeners);
        if (getListenerIndex(cb, userInterfaceListeners) !== -1) {
            userInterfaceListeners.splice(index, 1);
        }
    }

    function notifyUserInterfaceEvent(userInterfaceEvent) {
        userInterfaceListeners.forEach(function (listener) {
            try {
                listener(angular.copy(userInterfaceEvent));
            } catch (err) {
                // eslint-disable-next-line
                console.log('Error in watchman overlooker: ', err);
            }
        });
    }

    function getListenerIndex(cb, cbList) {
        var i = 0;
        while (i < cbList.length) {
            if (cb === cbList[i]) {
                return i;
            }
            i++;
        }
        return -1;
    }

    function addOrderEventListener(cb) {
        if (getListenerIndex(cb, orderEventsListeners) === -1) {
            return orderEventsListeners.push(cb);
        }
    }

    function removeOrderEventListener(cb) {
        var index = getListenerIndex(cb, orderEventsListeners);
        if (getListenerIndex(cb, orderEventsListeners) !== -1) {
            orderEventsListeners.splice(index, 1);
        }
    }

    function notifyOrderEvent(orderEvent, orderInfo) {
        orderEventsListeners.forEach(function (orderEventsListener) {
            try {
                orderEventsListener(angular.copy(orderEvent), angular.copy(orderInfo));
            } catch (err) {
                // eslint-disable-next-line
                console.log('Error in watchman overlooker: ', err);
            }
        });
    }
}]);

},{}]},{},[83]);
